export const demoBoard = ["7h", "Qs", "8s"];

export const timelineSave = [
  {
    text: "Preflop",
    snapshot: {
      board: [],
      notes: "",
      activeActionSetId: "preflopPolar",
      activeColorSchemeId: "default",
      subrangeByComboString: {
        AsAh: 0,
        AsAd: 0,
        AsAc: 0,
        AsKs: 0,
        AsKh: 0,
        AsKd: 0,
        AsKc: 0,
        AsQs: 0,
        AsQh: 2,
        AsQd: 2,
        AsQc: 2,
        AsJs: 2,
        AsJh: 1,
        AsJd: 1,
        AsJc: 1,
        AsTs: 2,
        AsTh: 3,
        AsTd: 3,
        AsTc: 3,
        As9s: 1,
        As9h: 3,
        As9d: 3,
        As9c: 3,
        As8s: 1,
        As8h: 3,
        As8d: 3,
        As8c: 3,
        As7s: 3,
        As7h: 3,
        As7d: 3,
        As7c: 3,
        As6s: 3,
        As6h: 3,
        As6d: 3,
        As6c: 3,
        As5s: 1,
        As5h: 3,
        As5d: 3,
        As5c: 3,
        As4s: 1,
        As4h: 3,
        As4d: 3,
        As4c: 3,
        As3s: 3,
        As3h: 3,
        As3d: 3,
        As3c: 3,
        As2s: 3,
        As2h: 3,
        As2d: 3,
        As2c: 3,
        AhAd: 0,
        AhAc: 0,
        AhKs: 0,
        AhKh: 0,
        AhKd: 0,
        AhKc: 0,
        AhQs: 2,
        AhQh: 0,
        AhQd: 2,
        AhQc: 2,
        AhJs: 1,
        AhJh: 2,
        AhJd: 1,
        AhJc: 1,
        AhTs: 3,
        AhTh: 2,
        AhTd: 3,
        AhTc: 3,
        Ah9s: 3,
        Ah9h: 1,
        Ah9d: 3,
        Ah9c: 3,
        Ah8s: 3,
        Ah8h: 1,
        Ah8d: 3,
        Ah8c: 3,
        Ah7s: 3,
        Ah7h: 3,
        Ah7d: 3,
        Ah7c: 3,
        Ah6s: 3,
        Ah6h: 3,
        Ah6d: 3,
        Ah6c: 3,
        Ah5s: 3,
        Ah5h: 1,
        Ah5d: 3,
        Ah5c: 3,
        Ah4s: 3,
        Ah4h: 1,
        Ah4d: 3,
        Ah4c: 3,
        Ah3s: 3,
        Ah3h: 3,
        Ah3d: 3,
        Ah3c: 3,
        Ah2s: 3,
        Ah2h: 3,
        Ah2d: 3,
        Ah2c: 3,
        AdAc: 0,
        AdKs: 0,
        AdKh: 0,
        AdKd: 0,
        AdKc: 0,
        AdQs: 2,
        AdQh: 2,
        AdQd: 0,
        AdQc: 2,
        AdJs: 1,
        AdJh: 1,
        AdJd: 2,
        AdJc: 1,
        AdTs: 3,
        AdTh: 3,
        AdTd: 2,
        AdTc: 3,
        Ad9s: 3,
        Ad9h: 3,
        Ad9d: 1,
        Ad9c: 3,
        Ad8s: 3,
        Ad8h: 3,
        Ad8d: 1,
        Ad8c: 3,
        Ad7s: 3,
        Ad7h: 3,
        Ad7d: 3,
        Ad7c: 3,
        Ad6s: 3,
        Ad6h: 3,
        Ad6d: 3,
        Ad6c: 3,
        Ad5s: 3,
        Ad5h: 3,
        Ad5d: 1,
        Ad5c: 3,
        Ad4s: 3,
        Ad4h: 3,
        Ad4d: 1,
        Ad4c: 3,
        Ad3s: 3,
        Ad3h: 3,
        Ad3d: 3,
        Ad3c: 3,
        Ad2s: 3,
        Ad2h: 3,
        Ad2d: 3,
        Ad2c: 3,
        AcKs: 0,
        AcKh: 0,
        AcKd: 0,
        AcKc: 0,
        AcQs: 2,
        AcQh: 2,
        AcQd: 2,
        AcQc: 0,
        AcJs: 1,
        AcJh: 1,
        AcJd: 1,
        AcJc: 2,
        AcTs: 3,
        AcTh: 3,
        AcTd: 3,
        AcTc: 2,
        Ac9s: 3,
        Ac9h: 3,
        Ac9d: 3,
        Ac9c: 1,
        Ac8s: 3,
        Ac8h: 3,
        Ac8d: 3,
        Ac8c: 1,
        Ac7s: 3,
        Ac7h: 3,
        Ac7d: 3,
        Ac7c: 3,
        Ac6s: 3,
        Ac6h: 3,
        Ac6d: 3,
        Ac6c: 3,
        Ac5s: 3,
        Ac5h: 3,
        Ac5d: 3,
        Ac5c: 1,
        Ac4s: 3,
        Ac4h: 3,
        Ac4d: 3,
        Ac4c: 1,
        Ac3s: 3,
        Ac3h: 3,
        Ac3d: 3,
        Ac3c: 3,
        Ac2s: 3,
        Ac2h: 3,
        Ac2d: 3,
        Ac2c: 3,
        KsKh: 0,
        KsKd: 0,
        KsKc: 0,
        KsQs: 2,
        KsQh: 1,
        KsQd: 1,
        KsQc: 1,
        KsJs: 2,
        KsJh: 3,
        KsJd: 3,
        KsJc: 3,
        KsTs: 2,
        KsTh: 3,
        KsTd: 3,
        KsTc: 3,
        Ks9s: 1,
        Ks9h: 3,
        Ks9d: 3,
        Ks9c: 3,
        Ks8s: 3,
        Ks8h: 3,
        Ks8d: 3,
        Ks8c: 3,
        Ks7s: 3,
        Ks7h: 3,
        Ks7d: 3,
        Ks7c: 3,
        Ks6s: 3,
        Ks6h: 3,
        Ks6d: 3,
        Ks6c: 3,
        Ks5s: 3,
        Ks5h: 3,
        Ks5d: 3,
        Ks5c: 3,
        Ks4s: 3,
        Ks4h: 3,
        Ks4d: 3,
        Ks4c: 3,
        Ks3s: 3,
        Ks3h: 3,
        Ks3d: 3,
        Ks3c: 3,
        Ks2s: 3,
        Ks2h: 3,
        Ks2d: 3,
        Ks2c: 3,
        KhKd: 0,
        KhKc: 0,
        KhQs: 1,
        KhQh: 2,
        KhQd: 1,
        KhQc: 1,
        KhJs: 3,
        KhJh: 2,
        KhJd: 3,
        KhJc: 3,
        KhTs: 3,
        KhTh: 2,
        KhTd: 3,
        KhTc: 3,
        Kh9s: 3,
        Kh9h: 1,
        Kh9d: 3,
        Kh9c: 3,
        Kh8s: 3,
        Kh8h: 3,
        Kh8d: 3,
        Kh8c: 3,
        Kh7s: 3,
        Kh7h: 3,
        Kh7d: 3,
        Kh7c: 3,
        Kh6s: 3,
        Kh6h: 3,
        Kh6d: 3,
        Kh6c: 3,
        Kh5s: 3,
        Kh5h: 3,
        Kh5d: 3,
        Kh5c: 3,
        Kh4s: 3,
        Kh4h: 3,
        Kh4d: 3,
        Kh4c: 3,
        Kh3s: 3,
        Kh3h: 3,
        Kh3d: 3,
        Kh3c: 3,
        Kh2s: 3,
        Kh2h: 3,
        Kh2d: 3,
        Kh2c: 3,
        KdKc: 0,
        KdQs: 1,
        KdQh: 1,
        KdQd: 2,
        KdQc: 1,
        KdJs: 3,
        KdJh: 3,
        KdJd: 2,
        KdJc: 3,
        KdTs: 3,
        KdTh: 3,
        KdTd: 2,
        KdTc: 3,
        Kd9s: 3,
        Kd9h: 3,
        Kd9d: 1,
        Kd9c: 3,
        Kd8s: 3,
        Kd8h: 3,
        Kd8d: 3,
        Kd8c: 3,
        Kd7s: 3,
        Kd7h: 3,
        Kd7d: 3,
        Kd7c: 3,
        Kd6s: 3,
        Kd6h: 3,
        Kd6d: 3,
        Kd6c: 3,
        Kd5s: 3,
        Kd5h: 3,
        Kd5d: 3,
        Kd5c: 3,
        Kd4s: 3,
        Kd4h: 3,
        Kd4d: 3,
        Kd4c: 3,
        Kd3s: 3,
        Kd3h: 3,
        Kd3d: 3,
        Kd3c: 3,
        Kd2s: 3,
        Kd2h: 3,
        Kd2d: 3,
        Kd2c: 3,
        KcQs: 1,
        KcQh: 1,
        KcQd: 1,
        KcQc: 2,
        KcJs: 3,
        KcJh: 3,
        KcJd: 3,
        KcJc: 2,
        KcTs: 3,
        KcTh: 3,
        KcTd: 3,
        KcTc: 2,
        Kc9s: 3,
        Kc9h: 3,
        Kc9d: 3,
        Kc9c: 1,
        Kc8s: 3,
        Kc8h: 3,
        Kc8d: 3,
        Kc8c: 3,
        Kc7s: 3,
        Kc7h: 3,
        Kc7d: 3,
        Kc7c: 3,
        Kc6s: 3,
        Kc6h: 3,
        Kc6d: 3,
        Kc6c: 3,
        Kc5s: 3,
        Kc5h: 3,
        Kc5d: 3,
        Kc5c: 3,
        Kc4s: 3,
        Kc4h: 3,
        Kc4d: 3,
        Kc4c: 3,
        Kc3s: 3,
        Kc3h: 3,
        Kc3d: 3,
        Kc3c: 3,
        Kc2s: 3,
        Kc2h: 3,
        Kc2d: 3,
        Kc2c: 3,
        QsQh: 0,
        QsQd: 0,
        QsQc: 0,
        QsJs: 1,
        QsJh: 3,
        QsJd: 3,
        QsJc: 3,
        QsTs: 2,
        QsTh: 3,
        QsTd: 3,
        QsTc: 3,
        Qs9s: 3,
        Qs9h: 3,
        Qs9d: 3,
        Qs9c: 3,
        Qs8s: 3,
        Qs8h: 3,
        Qs8d: 3,
        Qs8c: 3,
        Qs7s: 3,
        Qs7h: 3,
        Qs7d: 3,
        Qs7c: 3,
        Qs6s: 3,
        Qs6h: 3,
        Qs6d: 3,
        Qs6c: 3,
        Qs5s: 3,
        Qs5h: 3,
        Qs5d: 3,
        Qs5c: 3,
        Qs4s: 3,
        Qs4h: 3,
        Qs4d: 3,
        Qs4c: 3,
        Qs3s: 3,
        Qs3h: 3,
        Qs3d: 3,
        Qs3c: 3,
        Qs2s: 3,
        Qs2h: 3,
        Qs2d: 3,
        Qs2c: 3,
        QhQd: 0,
        QhQc: 0,
        QhJs: 3,
        QhJh: 1,
        QhJd: 3,
        QhJc: 3,
        QhTs: 3,
        QhTh: 2,
        QhTd: 3,
        QhTc: 3,
        Qh9s: 3,
        Qh9h: 3,
        Qh9d: 3,
        Qh9c: 3,
        Qh8s: 3,
        Qh8h: 3,
        Qh8d: 3,
        Qh8c: 3,
        Qh7s: 3,
        Qh7h: 3,
        Qh7d: 3,
        Qh7c: 3,
        Qh6s: 3,
        Qh6h: 3,
        Qh6d: 3,
        Qh6c: 3,
        Qh5s: 3,
        Qh5h: 3,
        Qh5d: 3,
        Qh5c: 3,
        Qh4s: 3,
        Qh4h: 3,
        Qh4d: 3,
        Qh4c: 3,
        Qh3s: 3,
        Qh3h: 3,
        Qh3d: 3,
        Qh3c: 3,
        Qh2s: 3,
        Qh2h: 3,
        Qh2d: 3,
        Qh2c: 3,
        QdQc: 0,
        QdJs: 3,
        QdJh: 3,
        QdJd: 1,
        QdJc: 3,
        QdTs: 3,
        QdTh: 3,
        QdTd: 2,
        QdTc: 3,
        Qd9s: 3,
        Qd9h: 3,
        Qd9d: 3,
        Qd9c: 3,
        Qd8s: 3,
        Qd8h: 3,
        Qd8d: 3,
        Qd8c: 3,
        Qd7s: 3,
        Qd7h: 3,
        Qd7d: 3,
        Qd7c: 3,
        Qd6s: 3,
        Qd6h: 3,
        Qd6d: 3,
        Qd6c: 3,
        Qd5s: 3,
        Qd5h: 3,
        Qd5d: 3,
        Qd5c: 3,
        Qd4s: 3,
        Qd4h: 3,
        Qd4d: 3,
        Qd4c: 3,
        Qd3s: 3,
        Qd3h: 3,
        Qd3d: 3,
        Qd3c: 3,
        Qd2s: 3,
        Qd2h: 3,
        Qd2d: 3,
        Qd2c: 3,
        QcJs: 3,
        QcJh: 3,
        QcJd: 3,
        QcJc: 1,
        QcTs: 3,
        QcTh: 3,
        QcTd: 3,
        QcTc: 2,
        Qc9s: 3,
        Qc9h: 3,
        Qc9d: 3,
        Qc9c: 3,
        Qc8s: 3,
        Qc8h: 3,
        Qc8d: 3,
        Qc8c: 3,
        Qc7s: 3,
        Qc7h: 3,
        Qc7d: 3,
        Qc7c: 3,
        Qc6s: 3,
        Qc6h: 3,
        Qc6d: 3,
        Qc6c: 3,
        Qc5s: 3,
        Qc5h: 3,
        Qc5d: 3,
        Qc5c: 3,
        Qc4s: 3,
        Qc4h: 3,
        Qc4d: 3,
        Qc4c: 3,
        Qc3s: 3,
        Qc3h: 3,
        Qc3d: 3,
        Qc3c: 3,
        Qc2s: 3,
        Qc2h: 3,
        Qc2d: 3,
        Qc2c: 3,
        JsJh: 0,
        JsJd: 0,
        JsJc: 0,
        JsTs: 2,
        JsTh: 3,
        JsTd: 3,
        JsTc: 3,
        Js9s: 3,
        Js9h: 3,
        Js9d: 3,
        Js9c: 3,
        Js8s: 3,
        Js8h: 3,
        Js8d: 3,
        Js8c: 3,
        Js7s: 3,
        Js7h: 3,
        Js7d: 3,
        Js7c: 3,
        Js6s: 3,
        Js6h: 3,
        Js6d: 3,
        Js6c: 3,
        Js5s: 3,
        Js5h: 3,
        Js5d: 3,
        Js5c: 3,
        Js4s: 3,
        Js4h: 3,
        Js4d: 3,
        Js4c: 3,
        Js3s: 3,
        Js3h: 3,
        Js3d: 3,
        Js3c: 3,
        Js2s: 3,
        Js2h: 3,
        Js2d: 3,
        Js2c: 3,
        JhJd: 0,
        JhJc: 0,
        JhTs: 3,
        JhTh: 2,
        JhTd: 3,
        JhTc: 3,
        Jh9s: 3,
        Jh9h: 3,
        Jh9d: 3,
        Jh9c: 3,
        Jh8s: 3,
        Jh8h: 3,
        Jh8d: 3,
        Jh8c: 3,
        Jh7s: 3,
        Jh7h: 3,
        Jh7d: 3,
        Jh7c: 3,
        Jh6s: 3,
        Jh6h: 3,
        Jh6d: 3,
        Jh6c: 3,
        Jh5s: 3,
        Jh5h: 3,
        Jh5d: 3,
        Jh5c: 3,
        Jh4s: 3,
        Jh4h: 3,
        Jh4d: 3,
        Jh4c: 3,
        Jh3s: 3,
        Jh3h: 3,
        Jh3d: 3,
        Jh3c: 3,
        Jh2s: 3,
        Jh2h: 3,
        Jh2d: 3,
        Jh2c: 3,
        JdJc: 0,
        JdTs: 3,
        JdTh: 3,
        JdTd: 2,
        JdTc: 3,
        Jd9s: 3,
        Jd9h: 3,
        Jd9d: 3,
        Jd9c: 3,
        Jd8s: 3,
        Jd8h: 3,
        Jd8d: 3,
        Jd8c: 3,
        Jd7s: 3,
        Jd7h: 3,
        Jd7d: 3,
        Jd7c: 3,
        Jd6s: 3,
        Jd6h: 3,
        Jd6d: 3,
        Jd6c: 3,
        Jd5s: 3,
        Jd5h: 3,
        Jd5d: 3,
        Jd5c: 3,
        Jd4s: 3,
        Jd4h: 3,
        Jd4d: 3,
        Jd4c: 3,
        Jd3s: 3,
        Jd3h: 3,
        Jd3d: 3,
        Jd3c: 3,
        Jd2s: 3,
        Jd2h: 3,
        Jd2d: 3,
        Jd2c: 3,
        JcTs: 3,
        JcTh: 3,
        JcTd: 3,
        JcTc: 2,
        Jc9s: 3,
        Jc9h: 3,
        Jc9d: 3,
        Jc9c: 3,
        Jc8s: 3,
        Jc8h: 3,
        Jc8d: 3,
        Jc8c: 3,
        Jc7s: 3,
        Jc7h: 3,
        Jc7d: 3,
        Jc7c: 3,
        Jc6s: 3,
        Jc6h: 3,
        Jc6d: 3,
        Jc6c: 3,
        Jc5s: 3,
        Jc5h: 3,
        Jc5d: 3,
        Jc5c: 3,
        Jc4s: 3,
        Jc4h: 3,
        Jc4d: 3,
        Jc4c: 3,
        Jc3s: 3,
        Jc3h: 3,
        Jc3d: 3,
        Jc3c: 3,
        Jc2s: 3,
        Jc2h: 3,
        Jc2d: 3,
        Jc2c: 3,
        TsTh: 2,
        TsTd: 2,
        TsTc: 2,
        Ts9s: 2,
        Ts9h: 3,
        Ts9d: 3,
        Ts9c: 3,
        Ts8s: 3,
        Ts8h: 3,
        Ts8d: 3,
        Ts8c: 3,
        Ts7s: 3,
        Ts7h: 3,
        Ts7d: 3,
        Ts7c: 3,
        Ts6s: 3,
        Ts6h: 3,
        Ts6d: 3,
        Ts6c: 3,
        Ts5s: 3,
        Ts5h: 3,
        Ts5d: 3,
        Ts5c: 3,
        Ts4s: 3,
        Ts4h: 3,
        Ts4d: 3,
        Ts4c: 3,
        Ts3s: 3,
        Ts3h: 3,
        Ts3d: 3,
        Ts3c: 3,
        Ts2s: 3,
        Ts2h: 3,
        Ts2d: 3,
        Ts2c: 3,
        ThTd: 2,
        ThTc: 2,
        Th9s: 3,
        Th9h: 2,
        Th9d: 3,
        Th9c: 3,
        Th8s: 3,
        Th8h: 3,
        Th8d: 3,
        Th8c: 3,
        Th7s: 3,
        Th7h: 3,
        Th7d: 3,
        Th7c: 3,
        Th6s: 3,
        Th6h: 3,
        Th6d: 3,
        Th6c: 3,
        Th5s: 3,
        Th5h: 3,
        Th5d: 3,
        Th5c: 3,
        Th4s: 3,
        Th4h: 3,
        Th4d: 3,
        Th4c: 3,
        Th3s: 3,
        Th3h: 3,
        Th3d: 3,
        Th3c: 3,
        Th2s: 3,
        Th2h: 3,
        Th2d: 3,
        Th2c: 3,
        TdTc: 2,
        Td9s: 3,
        Td9h: 3,
        Td9d: 2,
        Td9c: 3,
        Td8s: 3,
        Td8h: 3,
        Td8d: 3,
        Td8c: 3,
        Td7s: 3,
        Td7h: 3,
        Td7d: 3,
        Td7c: 3,
        Td6s: 3,
        Td6h: 3,
        Td6d: 3,
        Td6c: 3,
        Td5s: 3,
        Td5h: 3,
        Td5d: 3,
        Td5c: 3,
        Td4s: 3,
        Td4h: 3,
        Td4d: 3,
        Td4c: 3,
        Td3s: 3,
        Td3h: 3,
        Td3d: 3,
        Td3c: 3,
        Td2s: 3,
        Td2h: 3,
        Td2d: 3,
        Td2c: 3,
        Tc9s: 3,
        Tc9h: 3,
        Tc9d: 3,
        Tc9c: 2,
        Tc8s: 3,
        Tc8h: 3,
        Tc8d: 3,
        Tc8c: 3,
        Tc7s: 3,
        Tc7h: 3,
        Tc7d: 3,
        Tc7c: 3,
        Tc6s: 3,
        Tc6h: 3,
        Tc6d: 3,
        Tc6c: 3,
        Tc5s: 3,
        Tc5h: 3,
        Tc5d: 3,
        Tc5c: 3,
        Tc4s: 3,
        Tc4h: 3,
        Tc4d: 3,
        Tc4c: 3,
        Tc3s: 3,
        Tc3h: 3,
        Tc3d: 3,
        Tc3c: 3,
        Tc2s: 3,
        Tc2h: 3,
        Tc2d: 3,
        Tc2c: 3,
        "9s9h": 2,
        "9s9d": 2,
        "9s9c": 2,
        "9s8s": 2,
        "9s8h": 3,
        "9s8d": 3,
        "9s8c": 3,
        "9s7s": 3,
        "9s7h": 3,
        "9s7d": 3,
        "9s7c": 3,
        "9s6s": 3,
        "9s6h": 3,
        "9s6d": 3,
        "9s6c": 3,
        "9s5s": 3,
        "9s5h": 3,
        "9s5d": 3,
        "9s5c": 3,
        "9s4s": 3,
        "9s4h": 3,
        "9s4d": 3,
        "9s4c": 3,
        "9s3s": 3,
        "9s3h": 3,
        "9s3d": 3,
        "9s3c": 3,
        "9s2s": 3,
        "9s2h": 3,
        "9s2d": 3,
        "9s2c": 3,
        "9h9d": 2,
        "9h9c": 2,
        "9h8s": 3,
        "9h8h": 2,
        "9h8d": 3,
        "9h8c": 3,
        "9h7s": 3,
        "9h7h": 3,
        "9h7d": 3,
        "9h7c": 3,
        "9h6s": 3,
        "9h6h": 3,
        "9h6d": 3,
        "9h6c": 3,
        "9h5s": 3,
        "9h5h": 3,
        "9h5d": 3,
        "9h5c": 3,
        "9h4s": 3,
        "9h4h": 3,
        "9h4d": 3,
        "9h4c": 3,
        "9h3s": 3,
        "9h3h": 3,
        "9h3d": 3,
        "9h3c": 3,
        "9h2s": 3,
        "9h2h": 3,
        "9h2d": 3,
        "9h2c": 3,
        "9d9c": 2,
        "9d8s": 3,
        "9d8h": 3,
        "9d8d": 2,
        "9d8c": 3,
        "9d7s": 3,
        "9d7h": 3,
        "9d7d": 3,
        "9d7c": 3,
        "9d6s": 3,
        "9d6h": 3,
        "9d6d": 3,
        "9d6c": 3,
        "9d5s": 3,
        "9d5h": 3,
        "9d5d": 3,
        "9d5c": 3,
        "9d4s": 3,
        "9d4h": 3,
        "9d4d": 3,
        "9d4c": 3,
        "9d3s": 3,
        "9d3h": 3,
        "9d3d": 3,
        "9d3c": 3,
        "9d2s": 3,
        "9d2h": 3,
        "9d2d": 3,
        "9d2c": 3,
        "9c8s": 3,
        "9c8h": 3,
        "9c8d": 3,
        "9c8c": 2,
        "9c7s": 3,
        "9c7h": 3,
        "9c7d": 3,
        "9c7c": 3,
        "9c6s": 3,
        "9c6h": 3,
        "9c6d": 3,
        "9c6c": 3,
        "9c5s": 3,
        "9c5h": 3,
        "9c5d": 3,
        "9c5c": 3,
        "9c4s": 3,
        "9c4h": 3,
        "9c4d": 3,
        "9c4c": 3,
        "9c3s": 3,
        "9c3h": 3,
        "9c3d": 3,
        "9c3c": 3,
        "9c2s": 3,
        "9c2h": 3,
        "9c2d": 3,
        "9c2c": 3,
        "8s8h": 2,
        "8s8d": 2,
        "8s8c": 2,
        "8s7s": 2,
        "8s7h": 3,
        "8s7d": 3,
        "8s7c": 3,
        "8s6s": 3,
        "8s6h": 3,
        "8s6d": 3,
        "8s6c": 3,
        "8s5s": 3,
        "8s5h": 3,
        "8s5d": 3,
        "8s5c": 3,
        "8s4s": 3,
        "8s4h": 3,
        "8s4d": 3,
        "8s4c": 3,
        "8s3s": 3,
        "8s3h": 3,
        "8s3d": 3,
        "8s3c": 3,
        "8s2s": 3,
        "8s2h": 3,
        "8s2d": 3,
        "8s2c": 3,
        "8h8d": 2,
        "8h8c": 2,
        "8h7s": 3,
        "8h7h": 2,
        "8h7d": 3,
        "8h7c": 3,
        "8h6s": 3,
        "8h6h": 3,
        "8h6d": 3,
        "8h6c": 3,
        "8h5s": 3,
        "8h5h": 3,
        "8h5d": 3,
        "8h5c": 3,
        "8h4s": 3,
        "8h4h": 3,
        "8h4d": 3,
        "8h4c": 3,
        "8h3s": 3,
        "8h3h": 3,
        "8h3d": 3,
        "8h3c": 3,
        "8h2s": 3,
        "8h2h": 3,
        "8h2d": 3,
        "8h2c": 3,
        "8d8c": 2,
        "8d7s": 3,
        "8d7h": 3,
        "8d7d": 2,
        "8d7c": 3,
        "8d6s": 3,
        "8d6h": 3,
        "8d6d": 3,
        "8d6c": 3,
        "8d5s": 3,
        "8d5h": 3,
        "8d5d": 3,
        "8d5c": 3,
        "8d4s": 3,
        "8d4h": 3,
        "8d4d": 3,
        "8d4c": 3,
        "8d3s": 3,
        "8d3h": 3,
        "8d3d": 3,
        "8d3c": 3,
        "8d2s": 3,
        "8d2h": 3,
        "8d2d": 3,
        "8d2c": 3,
        "8c7s": 3,
        "8c7h": 3,
        "8c7d": 3,
        "8c7c": 2,
        "8c6s": 3,
        "8c6h": 3,
        "8c6d": 3,
        "8c6c": 3,
        "8c5s": 3,
        "8c5h": 3,
        "8c5d": 3,
        "8c5c": 3,
        "8c4s": 3,
        "8c4h": 3,
        "8c4d": 3,
        "8c4c": 3,
        "8c3s": 3,
        "8c3h": 3,
        "8c3d": 3,
        "8c3c": 3,
        "8c2s": 3,
        "8c2h": 3,
        "8c2d": 3,
        "8c2c": 3,
        "7s7h": 2,
        "7s7d": 2,
        "7s7c": 2,
        "7s6s": 1,
        "7s6h": 3,
        "7s6d": 3,
        "7s6c": 3,
        "7s5s": 3,
        "7s5h": 3,
        "7s5d": 3,
        "7s5c": 3,
        "7s4s": 3,
        "7s4h": 3,
        "7s4d": 3,
        "7s4c": 3,
        "7s3s": 3,
        "7s3h": 3,
        "7s3d": 3,
        "7s3c": 3,
        "7s2s": 3,
        "7s2h": 3,
        "7s2d": 3,
        "7s2c": 3,
        "7h7d": 2,
        "7h7c": 2,
        "7h6s": 3,
        "7h6h": 1,
        "7h6d": 3,
        "7h6c": 3,
        "7h5s": 3,
        "7h5h": 3,
        "7h5d": 3,
        "7h5c": 3,
        "7h4s": 3,
        "7h4h": 3,
        "7h4d": 3,
        "7h4c": 3,
        "7h3s": 3,
        "7h3h": 3,
        "7h3d": 3,
        "7h3c": 3,
        "7h2s": 3,
        "7h2h": 3,
        "7h2d": 3,
        "7h2c": 3,
        "7d7c": 2,
        "7d6s": 3,
        "7d6h": 3,
        "7d6d": 1,
        "7d6c": 3,
        "7d5s": 3,
        "7d5h": 3,
        "7d5d": 3,
        "7d5c": 3,
        "7d4s": 3,
        "7d4h": 3,
        "7d4d": 3,
        "7d4c": 3,
        "7d3s": 3,
        "7d3h": 3,
        "7d3d": 3,
        "7d3c": 3,
        "7d2s": 3,
        "7d2h": 3,
        "7d2d": 3,
        "7d2c": 3,
        "7c6s": 3,
        "7c6h": 3,
        "7c6d": 3,
        "7c6c": 1,
        "7c5s": 3,
        "7c5h": 3,
        "7c5d": 3,
        "7c5c": 3,
        "7c4s": 3,
        "7c4h": 3,
        "7c4d": 3,
        "7c4c": 3,
        "7c3s": 3,
        "7c3h": 3,
        "7c3d": 3,
        "7c3c": 3,
        "7c2s": 3,
        "7c2h": 3,
        "7c2d": 3,
        "7c2c": 3,
        "6s6h": 2,
        "6s6d": 2,
        "6s6c": 2,
        "6s5s": 1,
        "6s5h": 3,
        "6s5d": 3,
        "6s5c": 3,
        "6s4s": 3,
        "6s4h": 3,
        "6s4d": 3,
        "6s4c": 3,
        "6s3s": 3,
        "6s3h": 3,
        "6s3d": 3,
        "6s3c": 3,
        "6s2s": 3,
        "6s2h": 3,
        "6s2d": 3,
        "6s2c": 3,
        "6h6d": 2,
        "6h6c": 2,
        "6h5s": 3,
        "6h5h": 1,
        "6h5d": 3,
        "6h5c": 3,
        "6h4s": 3,
        "6h4h": 3,
        "6h4d": 3,
        "6h4c": 3,
        "6h3s": 3,
        "6h3h": 3,
        "6h3d": 3,
        "6h3c": 3,
        "6h2s": 3,
        "6h2h": 3,
        "6h2d": 3,
        "6h2c": 3,
        "6d6c": 2,
        "6d5s": 3,
        "6d5h": 3,
        "6d5d": 1,
        "6d5c": 3,
        "6d4s": 3,
        "6d4h": 3,
        "6d4d": 3,
        "6d4c": 3,
        "6d3s": 3,
        "6d3h": 3,
        "6d3d": 3,
        "6d3c": 3,
        "6d2s": 3,
        "6d2h": 3,
        "6d2d": 3,
        "6d2c": 3,
        "6c5s": 3,
        "6c5h": 3,
        "6c5d": 3,
        "6c5c": 1,
        "6c4s": 3,
        "6c4h": 3,
        "6c4d": 3,
        "6c4c": 3,
        "6c3s": 3,
        "6c3h": 3,
        "6c3d": 3,
        "6c3c": 3,
        "6c2s": 3,
        "6c2h": 3,
        "6c2d": 3,
        "6c2c": 3,
        "5s5h": 2,
        "5s5d": 2,
        "5s5c": 2,
        "5s4s": 1,
        "5s4h": 3,
        "5s4d": 3,
        "5s4c": 3,
        "5s3s": 3,
        "5s3h": 3,
        "5s3d": 3,
        "5s3c": 3,
        "5s2s": 3,
        "5s2h": 3,
        "5s2d": 3,
        "5s2c": 3,
        "5h5d": 2,
        "5h5c": 2,
        "5h4s": 3,
        "5h4h": 1,
        "5h4d": 3,
        "5h4c": 3,
        "5h3s": 3,
        "5h3h": 3,
        "5h3d": 3,
        "5h3c": 3,
        "5h2s": 3,
        "5h2h": 3,
        "5h2d": 3,
        "5h2c": 3,
        "5d5c": 2,
        "5d4s": 3,
        "5d4h": 3,
        "5d4d": 1,
        "5d4c": 3,
        "5d3s": 3,
        "5d3h": 3,
        "5d3d": 3,
        "5d3c": 3,
        "5d2s": 3,
        "5d2h": 3,
        "5d2d": 3,
        "5d2c": 3,
        "5c4s": 3,
        "5c4h": 3,
        "5c4d": 3,
        "5c4c": 1,
        "5c3s": 3,
        "5c3h": 3,
        "5c3d": 3,
        "5c3c": 3,
        "5c2s": 3,
        "5c2h": 3,
        "5c2d": 3,
        "5c2c": 3,
        "4s4h": 2,
        "4s4d": 2,
        "4s4c": 2,
        "4s3s": 3,
        "4s3h": 3,
        "4s3d": 3,
        "4s3c": 3,
        "4s2s": 3,
        "4s2h": 3,
        "4s2d": 3,
        "4s2c": 3,
        "4h4d": 2,
        "4h4c": 2,
        "4h3s": 3,
        "4h3h": 3,
        "4h3d": 3,
        "4h3c": 3,
        "4h2s": 3,
        "4h2h": 3,
        "4h2d": 3,
        "4h2c": 3,
        "4d4c": 2,
        "4d3s": 3,
        "4d3h": 3,
        "4d3d": 3,
        "4d3c": 3,
        "4d2s": 3,
        "4d2h": 3,
        "4d2d": 3,
        "4d2c": 3,
        "4c3s": 3,
        "4c3h": 3,
        "4c3d": 3,
        "4c3c": 3,
        "4c2s": 3,
        "4c2h": 3,
        "4c2d": 3,
        "4c2c": 3,
        "3s3h": 3,
        "3s3d": 3,
        "3s3c": 3,
        "3s2s": 3,
        "3s2h": 3,
        "3s2d": 3,
        "3s2c": 3,
        "3h3d": 3,
        "3h3c": 3,
        "3h2s": 3,
        "3h2h": 3,
        "3h2d": 3,
        "3h2c": 3,
        "3d3c": 3,
        "3d2s": 3,
        "3d2h": 3,
        "3d2d": 3,
        "3d2c": 3,
        "3c2s": 3,
        "3c2h": 3,
        "3c2d": 3,
        "3c2c": 3,
        "2s2h": 3,
        "2s2d": 3,
        "2s2c": 3,
        "2h2d": 3,
        "2h2c": 3,
        "2d2c": 3,
      },
      fixedCards: 0,
    },
    id: 0,
    action: "Call",
  },
  {
    text: "Flop",
    snapshot: {
      board: ["8c", "5d", "3s"],
      notes: "",
      activeActionSetId: "postflopAggressor",
      activeColorSchemeId: "default",
      subrangeByComboString: {
        AsAh: -1,
        AsAd: -1,
        AsAc: -1,
        AsKs: -1,
        AsKh: -1,
        AsKd: -1,
        AsKc: -1,
        AsQs: -1,
        AsQh: 2,
        AsQd: 2,
        AsQc: 2,
        AsJs: 2,
        AsJh: -1,
        AsJd: -1,
        AsJc: -1,
        AsTs: 1,
        AsTh: -1,
        AsTd: -1,
        AsTc: -1,
        As9s: -1,
        As9h: -1,
        As9d: -1,
        As9c: -1,
        As8s: -1,
        As8h: -1,
        As8d: -1,
        As8c: -1,
        As7s: -1,
        As7h: -1,
        As7d: -1,
        As7c: -1,
        As6s: -1,
        As6h: -1,
        As6d: -1,
        As6c: -1,
        As5s: -1,
        As5h: -1,
        As5d: -1,
        As5c: -1,
        As4s: -1,
        As4h: -1,
        As4d: -1,
        As4c: -1,
        As3s: -1,
        As3h: -1,
        As3d: -1,
        As3c: -1,
        As2s: -1,
        As2h: -1,
        As2d: -1,
        As2c: -1,
        AhAd: -1,
        AhAc: -1,
        AhKs: -1,
        AhKh: -1,
        AhKd: -1,
        AhKc: -1,
        AhQs: 2,
        AhQh: -1,
        AhQd: 2,
        AhQc: 2,
        AhJs: -1,
        AhJh: 2,
        AhJd: -1,
        AhJc: -1,
        AhTs: -1,
        AhTh: 3,
        AhTd: -1,
        AhTc: -1,
        Ah9s: -1,
        Ah9h: -1,
        Ah9d: -1,
        Ah9c: -1,
        Ah8s: -1,
        Ah8h: -1,
        Ah8d: -1,
        Ah8c: -1,
        Ah7s: -1,
        Ah7h: -1,
        Ah7d: -1,
        Ah7c: -1,
        Ah6s: -1,
        Ah6h: -1,
        Ah6d: -1,
        Ah6c: -1,
        Ah5s: -1,
        Ah5h: -1,
        Ah5d: -1,
        Ah5c: -1,
        Ah4s: -1,
        Ah4h: -1,
        Ah4d: -1,
        Ah4c: -1,
        Ah3s: -1,
        Ah3h: -1,
        Ah3d: -1,
        Ah3c: -1,
        Ah2s: -1,
        Ah2h: -1,
        Ah2d: -1,
        Ah2c: -1,
        AdAc: -1,
        AdKs: -1,
        AdKh: -1,
        AdKd: -1,
        AdKc: -1,
        AdQs: 2,
        AdQh: 2,
        AdQd: -1,
        AdQc: 2,
        AdJs: -1,
        AdJh: -1,
        AdJd: 2,
        AdJc: -1,
        AdTs: -1,
        AdTh: -1,
        AdTd: 1,
        AdTc: -1,
        Ad9s: -1,
        Ad9h: -1,
        Ad9d: -1,
        Ad9c: -1,
        Ad8s: -1,
        Ad8h: -1,
        Ad8d: -1,
        Ad8c: -1,
        Ad7s: -1,
        Ad7h: -1,
        Ad7d: -1,
        Ad7c: -1,
        Ad6s: -1,
        Ad6h: -1,
        Ad6d: -1,
        Ad6c: -1,
        Ad5s: -1,
        Ad5h: -1,
        Ad5d: -1,
        Ad5c: -1,
        Ad4s: -1,
        Ad4h: -1,
        Ad4d: -1,
        Ad4c: -1,
        Ad3s: -1,
        Ad3h: -1,
        Ad3d: -1,
        Ad3c: -1,
        Ad2s: -1,
        Ad2h: -1,
        Ad2d: -1,
        Ad2c: -1,
        AcKs: -1,
        AcKh: -1,
        AcKd: -1,
        AcKc: -1,
        AcQs: 2,
        AcQh: 2,
        AcQd: 2,
        AcQc: -1,
        AcJs: -1,
        AcJh: -1,
        AcJd: -1,
        AcJc: 2,
        AcTs: -1,
        AcTh: -1,
        AcTd: -1,
        AcTc: 1,
        Ac9s: -1,
        Ac9h: -1,
        Ac9d: -1,
        Ac9c: -1,
        Ac8s: -1,
        Ac8h: -1,
        Ac8d: -1,
        Ac8c: -1,
        Ac7s: -1,
        Ac7h: -1,
        Ac7d: -1,
        Ac7c: -1,
        Ac6s: -1,
        Ac6h: -1,
        Ac6d: -1,
        Ac6c: -1,
        Ac5s: -1,
        Ac5h: -1,
        Ac5d: -1,
        Ac5c: -1,
        Ac4s: -1,
        Ac4h: -1,
        Ac4d: -1,
        Ac4c: -1,
        Ac3s: -1,
        Ac3h: -1,
        Ac3d: -1,
        Ac3c: -1,
        Ac2s: -1,
        Ac2h: -1,
        Ac2d: -1,
        Ac2c: -1,
        KsKh: -1,
        KsKd: -1,
        KsKc: -1,
        KsQs: 1,
        KsQh: -1,
        KsQd: -1,
        KsQc: -1,
        KsJs: 1,
        KsJh: -1,
        KsJd: -1,
        KsJc: -1,
        KsTs: 1,
        KsTh: -1,
        KsTd: -1,
        KsTc: -1,
        Ks9s: -1,
        Ks9h: -1,
        Ks9d: -1,
        Ks9c: -1,
        Ks8s: -1,
        Ks8h: -1,
        Ks8d: -1,
        Ks8c: -1,
        Ks7s: -1,
        Ks7h: -1,
        Ks7d: -1,
        Ks7c: -1,
        Ks6s: -1,
        Ks6h: -1,
        Ks6d: -1,
        Ks6c: -1,
        Ks5s: -1,
        Ks5h: -1,
        Ks5d: -1,
        Ks5c: -1,
        Ks4s: -1,
        Ks4h: -1,
        Ks4d: -1,
        Ks4c: -1,
        Ks3s: -1,
        Ks3h: -1,
        Ks3d: -1,
        Ks3c: -1,
        Ks2s: -1,
        Ks2h: -1,
        Ks2d: -1,
        Ks2c: -1,
        KhKd: -1,
        KhKc: -1,
        KhQs: -1,
        KhQh: 3,
        KhQd: -1,
        KhQc: -1,
        KhJs: -1,
        KhJh: 3,
        KhJd: -1,
        KhJc: -1,
        KhTs: -1,
        KhTh: 3,
        KhTd: -1,
        KhTc: -1,
        Kh9s: -1,
        Kh9h: -1,
        Kh9d: -1,
        Kh9c: -1,
        Kh8s: -1,
        Kh8h: -1,
        Kh8d: -1,
        Kh8c: -1,
        Kh7s: -1,
        Kh7h: -1,
        Kh7d: -1,
        Kh7c: -1,
        Kh6s: -1,
        Kh6h: -1,
        Kh6d: -1,
        Kh6c: -1,
        Kh5s: -1,
        Kh5h: -1,
        Kh5d: -1,
        Kh5c: -1,
        Kh4s: -1,
        Kh4h: -1,
        Kh4d: -1,
        Kh4c: -1,
        Kh3s: -1,
        Kh3h: -1,
        Kh3d: -1,
        Kh3c: -1,
        Kh2s: -1,
        Kh2h: -1,
        Kh2d: -1,
        Kh2c: -1,
        KdKc: -1,
        KdQs: -1,
        KdQh: -1,
        KdQd: 1,
        KdQc: -1,
        KdJs: -1,
        KdJh: -1,
        KdJd: 1,
        KdJc: -1,
        KdTs: -1,
        KdTh: -1,
        KdTd: 1,
        KdTc: -1,
        Kd9s: -1,
        Kd9h: -1,
        Kd9d: -1,
        Kd9c: -1,
        Kd8s: -1,
        Kd8h: -1,
        Kd8d: -1,
        Kd8c: -1,
        Kd7s: -1,
        Kd7h: -1,
        Kd7d: -1,
        Kd7c: -1,
        Kd6s: -1,
        Kd6h: -1,
        Kd6d: -1,
        Kd6c: -1,
        Kd5s: -1,
        Kd5h: -1,
        Kd5d: -1,
        Kd5c: -1,
        Kd4s: -1,
        Kd4h: -1,
        Kd4d: -1,
        Kd4c: -1,
        Kd3s: -1,
        Kd3h: -1,
        Kd3d: -1,
        Kd3c: -1,
        Kd2s: -1,
        Kd2h: -1,
        Kd2d: -1,
        Kd2c: -1,
        KcQs: -1,
        KcQh: -1,
        KcQd: -1,
        KcQc: 1,
        KcJs: -1,
        KcJh: -1,
        KcJd: -1,
        KcJc: 1,
        KcTs: -1,
        KcTh: -1,
        KcTd: -1,
        KcTc: 1,
        Kc9s: -1,
        Kc9h: -1,
        Kc9d: -1,
        Kc9c: -1,
        Kc8s: -1,
        Kc8h: -1,
        Kc8d: -1,
        Kc8c: -1,
        Kc7s: -1,
        Kc7h: -1,
        Kc7d: -1,
        Kc7c: -1,
        Kc6s: -1,
        Kc6h: -1,
        Kc6d: -1,
        Kc6c: -1,
        Kc5s: -1,
        Kc5h: -1,
        Kc5d: -1,
        Kc5c: -1,
        Kc4s: -1,
        Kc4h: -1,
        Kc4d: -1,
        Kc4c: -1,
        Kc3s: -1,
        Kc3h: -1,
        Kc3d: -1,
        Kc3c: -1,
        Kc2s: -1,
        Kc2h: -1,
        Kc2d: -1,
        Kc2c: -1,
        QsQh: -1,
        QsQd: -1,
        QsQc: -1,
        QsJs: -1,
        QsJh: -1,
        QsJd: -1,
        QsJc: -1,
        QsTs: 1,
        QsTh: -1,
        QsTd: -1,
        QsTc: -1,
        Qs9s: -1,
        Qs9h: -1,
        Qs9d: -1,
        Qs9c: -1,
        Qs8s: -1,
        Qs8h: -1,
        Qs8d: -1,
        Qs8c: -1,
        Qs7s: -1,
        Qs7h: -1,
        Qs7d: -1,
        Qs7c: -1,
        Qs6s: -1,
        Qs6h: -1,
        Qs6d: -1,
        Qs6c: -1,
        Qs5s: -1,
        Qs5h: -1,
        Qs5d: -1,
        Qs5c: -1,
        Qs4s: -1,
        Qs4h: -1,
        Qs4d: -1,
        Qs4c: -1,
        Qs3s: -1,
        Qs3h: -1,
        Qs3d: -1,
        Qs3c: -1,
        Qs2s: -1,
        Qs2h: -1,
        Qs2d: -1,
        Qs2c: -1,
        QhQd: -1,
        QhQc: -1,
        QhJs: -1,
        QhJh: -1,
        QhJd: -1,
        QhJc: -1,
        QhTs: -1,
        QhTh: 1,
        QhTd: -1,
        QhTc: -1,
        Qh9s: -1,
        Qh9h: -1,
        Qh9d: -1,
        Qh9c: -1,
        Qh8s: -1,
        Qh8h: -1,
        Qh8d: -1,
        Qh8c: -1,
        Qh7s: -1,
        Qh7h: -1,
        Qh7d: -1,
        Qh7c: -1,
        Qh6s: -1,
        Qh6h: -1,
        Qh6d: -1,
        Qh6c: -1,
        Qh5s: -1,
        Qh5h: -1,
        Qh5d: -1,
        Qh5c: -1,
        Qh4s: -1,
        Qh4h: -1,
        Qh4d: -1,
        Qh4c: -1,
        Qh3s: -1,
        Qh3h: -1,
        Qh3d: -1,
        Qh3c: -1,
        Qh2s: -1,
        Qh2h: -1,
        Qh2d: -1,
        Qh2c: -1,
        QdQc: -1,
        QdJs: -1,
        QdJh: -1,
        QdJd: -1,
        QdJc: -1,
        QdTs: -1,
        QdTh: -1,
        QdTd: 1,
        QdTc: -1,
        Qd9s: -1,
        Qd9h: -1,
        Qd9d: -1,
        Qd9c: -1,
        Qd8s: -1,
        Qd8h: -1,
        Qd8d: -1,
        Qd8c: -1,
        Qd7s: -1,
        Qd7h: -1,
        Qd7d: -1,
        Qd7c: -1,
        Qd6s: -1,
        Qd6h: -1,
        Qd6d: -1,
        Qd6c: -1,
        Qd5s: -1,
        Qd5h: -1,
        Qd5d: -1,
        Qd5c: -1,
        Qd4s: -1,
        Qd4h: -1,
        Qd4d: -1,
        Qd4c: -1,
        Qd3s: -1,
        Qd3h: -1,
        Qd3d: -1,
        Qd3c: -1,
        Qd2s: -1,
        Qd2h: -1,
        Qd2d: -1,
        Qd2c: -1,
        QcJs: -1,
        QcJh: -1,
        QcJd: -1,
        QcJc: -1,
        QcTs: -1,
        QcTh: -1,
        QcTd: -1,
        QcTc: 1,
        Qc9s: -1,
        Qc9h: -1,
        Qc9d: -1,
        Qc9c: -1,
        Qc8s: -1,
        Qc8h: -1,
        Qc8d: -1,
        Qc8c: -1,
        Qc7s: -1,
        Qc7h: -1,
        Qc7d: -1,
        Qc7c: -1,
        Qc6s: -1,
        Qc6h: -1,
        Qc6d: -1,
        Qc6c: -1,
        Qc5s: -1,
        Qc5h: -1,
        Qc5d: -1,
        Qc5c: -1,
        Qc4s: -1,
        Qc4h: -1,
        Qc4d: -1,
        Qc4c: -1,
        Qc3s: -1,
        Qc3h: -1,
        Qc3d: -1,
        Qc3c: -1,
        Qc2s: -1,
        Qc2h: -1,
        Qc2d: -1,
        Qc2c: -1,
        JsJh: -1,
        JsJd: -1,
        JsJc: -1,
        JsTs: 1,
        JsTh: -1,
        JsTd: -1,
        JsTc: -1,
        Js9s: -1,
        Js9h: -1,
        Js9d: -1,
        Js9c: -1,
        Js8s: -1,
        Js8h: -1,
        Js8d: -1,
        Js8c: -1,
        Js7s: -1,
        Js7h: -1,
        Js7d: -1,
        Js7c: -1,
        Js6s: -1,
        Js6h: -1,
        Js6d: -1,
        Js6c: -1,
        Js5s: -1,
        Js5h: -1,
        Js5d: -1,
        Js5c: -1,
        Js4s: -1,
        Js4h: -1,
        Js4d: -1,
        Js4c: -1,
        Js3s: -1,
        Js3h: -1,
        Js3d: -1,
        Js3c: -1,
        Js2s: -1,
        Js2h: -1,
        Js2d: -1,
        Js2c: -1,
        JhJd: -1,
        JhJc: -1,
        JhTs: -1,
        JhTh: 1,
        JhTd: -1,
        JhTc: -1,
        Jh9s: -1,
        Jh9h: -1,
        Jh9d: -1,
        Jh9c: -1,
        Jh8s: -1,
        Jh8h: -1,
        Jh8d: -1,
        Jh8c: -1,
        Jh7s: -1,
        Jh7h: -1,
        Jh7d: -1,
        Jh7c: -1,
        Jh6s: -1,
        Jh6h: -1,
        Jh6d: -1,
        Jh6c: -1,
        Jh5s: -1,
        Jh5h: -1,
        Jh5d: -1,
        Jh5c: -1,
        Jh4s: -1,
        Jh4h: -1,
        Jh4d: -1,
        Jh4c: -1,
        Jh3s: -1,
        Jh3h: -1,
        Jh3d: -1,
        Jh3c: -1,
        Jh2s: -1,
        Jh2h: -1,
        Jh2d: -1,
        Jh2c: -1,
        JdJc: -1,
        JdTs: -1,
        JdTh: -1,
        JdTd: 1,
        JdTc: -1,
        Jd9s: -1,
        Jd9h: -1,
        Jd9d: -1,
        Jd9c: -1,
        Jd8s: -1,
        Jd8h: -1,
        Jd8d: -1,
        Jd8c: -1,
        Jd7s: -1,
        Jd7h: -1,
        Jd7d: -1,
        Jd7c: -1,
        Jd6s: -1,
        Jd6h: -1,
        Jd6d: -1,
        Jd6c: -1,
        Jd5s: -1,
        Jd5h: -1,
        Jd5d: -1,
        Jd5c: -1,
        Jd4s: -1,
        Jd4h: -1,
        Jd4d: -1,
        Jd4c: -1,
        Jd3s: -1,
        Jd3h: -1,
        Jd3d: -1,
        Jd3c: -1,
        Jd2s: -1,
        Jd2h: -1,
        Jd2d: -1,
        Jd2c: -1,
        JcTs: -1,
        JcTh: -1,
        JcTd: -1,
        JcTc: 1,
        Jc9s: -1,
        Jc9h: -1,
        Jc9d: -1,
        Jc9c: -1,
        Jc8s: -1,
        Jc8h: -1,
        Jc8d: -1,
        Jc8c: -1,
        Jc7s: -1,
        Jc7h: -1,
        Jc7d: -1,
        Jc7c: -1,
        Jc6s: -1,
        Jc6h: -1,
        Jc6d: -1,
        Jc6c: -1,
        Jc5s: -1,
        Jc5h: -1,
        Jc5d: -1,
        Jc5c: -1,
        Jc4s: -1,
        Jc4h: -1,
        Jc4d: -1,
        Jc4c: -1,
        Jc3s: -1,
        Jc3h: -1,
        Jc3d: -1,
        Jc3c: -1,
        Jc2s: -1,
        Jc2h: -1,
        Jc2d: -1,
        Jc2c: -1,
        TsTh: 0,
        TsTd: 0,
        TsTc: 0,
        Ts9s: 1,
        Ts9h: -1,
        Ts9d: -1,
        Ts9c: -1,
        Ts8s: -1,
        Ts8h: -1,
        Ts8d: -1,
        Ts8c: -1,
        Ts7s: -1,
        Ts7h: -1,
        Ts7d: -1,
        Ts7c: -1,
        Ts6s: -1,
        Ts6h: -1,
        Ts6d: -1,
        Ts6c: -1,
        Ts5s: -1,
        Ts5h: -1,
        Ts5d: -1,
        Ts5c: -1,
        Ts4s: -1,
        Ts4h: -1,
        Ts4d: -1,
        Ts4c: -1,
        Ts3s: -1,
        Ts3h: -1,
        Ts3d: -1,
        Ts3c: -1,
        Ts2s: -1,
        Ts2h: -1,
        Ts2d: -1,
        Ts2c: -1,
        ThTd: 0,
        ThTc: 0,
        Th9s: -1,
        Th9h: 1,
        Th9d: -1,
        Th9c: -1,
        Th8s: -1,
        Th8h: -1,
        Th8d: -1,
        Th8c: -1,
        Th7s: -1,
        Th7h: -1,
        Th7d: -1,
        Th7c: -1,
        Th6s: -1,
        Th6h: -1,
        Th6d: -1,
        Th6c: -1,
        Th5s: -1,
        Th5h: -1,
        Th5d: -1,
        Th5c: -1,
        Th4s: -1,
        Th4h: -1,
        Th4d: -1,
        Th4c: -1,
        Th3s: -1,
        Th3h: -1,
        Th3d: -1,
        Th3c: -1,
        Th2s: -1,
        Th2h: -1,
        Th2d: -1,
        Th2c: -1,
        TdTc: 0,
        Td9s: -1,
        Td9h: -1,
        Td9d: 1,
        Td9c: -1,
        Td8s: -1,
        Td8h: -1,
        Td8d: -1,
        Td8c: -1,
        Td7s: -1,
        Td7h: -1,
        Td7d: -1,
        Td7c: -1,
        Td6s: -1,
        Td6h: -1,
        Td6d: -1,
        Td6c: -1,
        Td5s: -1,
        Td5h: -1,
        Td5d: -1,
        Td5c: -1,
        Td4s: -1,
        Td4h: -1,
        Td4d: -1,
        Td4c: -1,
        Td3s: -1,
        Td3h: -1,
        Td3d: -1,
        Td3c: -1,
        Td2s: -1,
        Td2h: -1,
        Td2d: -1,
        Td2c: -1,
        Tc9s: -1,
        Tc9h: -1,
        Tc9d: -1,
        Tc9c: 1,
        Tc8s: -1,
        Tc8h: -1,
        Tc8d: -1,
        Tc8c: -1,
        Tc7s: -1,
        Tc7h: -1,
        Tc7d: -1,
        Tc7c: -1,
        Tc6s: -1,
        Tc6h: -1,
        Tc6d: -1,
        Tc6c: -1,
        Tc5s: -1,
        Tc5h: -1,
        Tc5d: -1,
        Tc5c: -1,
        Tc4s: -1,
        Tc4h: -1,
        Tc4d: -1,
        Tc4c: -1,
        Tc3s: -1,
        Tc3h: -1,
        Tc3d: -1,
        Tc3c: -1,
        Tc2s: -1,
        Tc2h: -1,
        Tc2d: -1,
        Tc2c: -1,
        "9s9h": 0,
        "9s9d": 0,
        "9s9c": 0,
        "9s8s": 0,
        "9s8h": -1,
        "9s8d": -1,
        "9s8c": -1,
        "9s7s": -1,
        "9s7h": -1,
        "9s7d": -1,
        "9s7c": -1,
        "9s6s": -1,
        "9s6h": -1,
        "9s6d": -1,
        "9s6c": -1,
        "9s5s": -1,
        "9s5h": -1,
        "9s5d": -1,
        "9s5c": -1,
        "9s4s": -1,
        "9s4h": -1,
        "9s4d": -1,
        "9s4c": -1,
        "9s3s": -1,
        "9s3h": -1,
        "9s3d": -1,
        "9s3c": -1,
        "9s2s": -1,
        "9s2h": -1,
        "9s2d": -1,
        "9s2c": -1,
        "9h9d": 0,
        "9h9c": 0,
        "9h8s": -1,
        "9h8h": 0,
        "9h8d": -1,
        "9h8c": -1,
        "9h7s": -1,
        "9h7h": -1,
        "9h7d": -1,
        "9h7c": -1,
        "9h6s": -1,
        "9h6h": -1,
        "9h6d": -1,
        "9h6c": -1,
        "9h5s": -1,
        "9h5h": -1,
        "9h5d": -1,
        "9h5c": -1,
        "9h4s": -1,
        "9h4h": -1,
        "9h4d": -1,
        "9h4c": -1,
        "9h3s": -1,
        "9h3h": -1,
        "9h3d": -1,
        "9h3c": -1,
        "9h2s": -1,
        "9h2h": -1,
        "9h2d": -1,
        "9h2c": -1,
        "9d9c": 0,
        "9d8s": -1,
        "9d8h": -1,
        "9d8d": 0,
        "9d8c": -1,
        "9d7s": -1,
        "9d7h": -1,
        "9d7d": -1,
        "9d7c": -1,
        "9d6s": -1,
        "9d6h": -1,
        "9d6d": -1,
        "9d6c": -1,
        "9d5s": -1,
        "9d5h": -1,
        "9d5d": -1,
        "9d5c": -1,
        "9d4s": -1,
        "9d4h": -1,
        "9d4d": -1,
        "9d4c": -1,
        "9d3s": -1,
        "9d3h": -1,
        "9d3d": -1,
        "9d3c": -1,
        "9d2s": -1,
        "9d2h": -1,
        "9d2d": -1,
        "9d2c": -1,
        "9c8s": -1,
        "9c8h": -1,
        "9c8d": -1,
        "9c8c": 0,
        "9c7s": -1,
        "9c7h": -1,
        "9c7d": -1,
        "9c7c": -1,
        "9c6s": -1,
        "9c6h": -1,
        "9c6d": -1,
        "9c6c": -1,
        "9c5s": -1,
        "9c5h": -1,
        "9c5d": -1,
        "9c5c": -1,
        "9c4s": -1,
        "9c4h": -1,
        "9c4d": -1,
        "9c4c": -1,
        "9c3s": -1,
        "9c3h": -1,
        "9c3d": -1,
        "9c3c": -1,
        "9c2s": -1,
        "9c2h": -1,
        "9c2d": -1,
        "9c2c": -1,
        "8s8h": 0,
        "8s8d": 0,
        "8s8c": 0,
        "8s7s": 2,
        "8s7h": -1,
        "8s7d": -1,
        "8s7c": -1,
        "8s6s": -1,
        "8s6h": -1,
        "8s6d": -1,
        "8s6c": -1,
        "8s5s": -1,
        "8s5h": -1,
        "8s5d": -1,
        "8s5c": -1,
        "8s4s": -1,
        "8s4h": -1,
        "8s4d": -1,
        "8s4c": -1,
        "8s3s": -1,
        "8s3h": -1,
        "8s3d": -1,
        "8s3c": -1,
        "8s2s": -1,
        "8s2h": -1,
        "8s2d": -1,
        "8s2c": -1,
        "8h8d": 0,
        "8h8c": 0,
        "8h7s": -1,
        "8h7h": 2,
        "8h7d": -1,
        "8h7c": -1,
        "8h6s": -1,
        "8h6h": -1,
        "8h6d": -1,
        "8h6c": -1,
        "8h5s": -1,
        "8h5h": -1,
        "8h5d": -1,
        "8h5c": -1,
        "8h4s": -1,
        "8h4h": -1,
        "8h4d": -1,
        "8h4c": -1,
        "8h3s": -1,
        "8h3h": -1,
        "8h3d": -1,
        "8h3c": -1,
        "8h2s": -1,
        "8h2h": -1,
        "8h2d": -1,
        "8h2c": -1,
        "8d8c": 0,
        "8d7s": -1,
        "8d7h": -1,
        "8d7d": 2,
        "8d7c": -1,
        "8d6s": -1,
        "8d6h": -1,
        "8d6d": -1,
        "8d6c": -1,
        "8d5s": -1,
        "8d5h": -1,
        "8d5d": -1,
        "8d5c": -1,
        "8d4s": -1,
        "8d4h": -1,
        "8d4d": -1,
        "8d4c": -1,
        "8d3s": -1,
        "8d3h": -1,
        "8d3d": -1,
        "8d3c": -1,
        "8d2s": -1,
        "8d2h": -1,
        "8d2d": -1,
        "8d2c": -1,
        "8c7s": -1,
        "8c7h": -1,
        "8c7d": -1,
        "8c7c": 2,
        "8c6s": -1,
        "8c6h": -1,
        "8c6d": -1,
        "8c6c": -1,
        "8c5s": -1,
        "8c5h": -1,
        "8c5d": -1,
        "8c5c": -1,
        "8c4s": -1,
        "8c4h": -1,
        "8c4d": -1,
        "8c4c": -1,
        "8c3s": -1,
        "8c3h": -1,
        "8c3d": -1,
        "8c3c": -1,
        "8c2s": -1,
        "8c2h": -1,
        "8c2d": -1,
        "8c2c": -1,
        "7s7h": 2,
        "7s7d": 2,
        "7s7c": 2,
        "7s6s": -1,
        "7s6h": -1,
        "7s6d": -1,
        "7s6c": -1,
        "7s5s": -1,
        "7s5h": -1,
        "7s5d": -1,
        "7s5c": -1,
        "7s4s": -1,
        "7s4h": -1,
        "7s4d": -1,
        "7s4c": -1,
        "7s3s": -1,
        "7s3h": -1,
        "7s3d": -1,
        "7s3c": -1,
        "7s2s": -1,
        "7s2h": -1,
        "7s2d": -1,
        "7s2c": -1,
        "7h7d": 2,
        "7h7c": 2,
        "7h6s": -1,
        "7h6h": -1,
        "7h6d": -1,
        "7h6c": -1,
        "7h5s": -1,
        "7h5h": -1,
        "7h5d": -1,
        "7h5c": -1,
        "7h4s": -1,
        "7h4h": -1,
        "7h4d": -1,
        "7h4c": -1,
        "7h3s": -1,
        "7h3h": -1,
        "7h3d": -1,
        "7h3c": -1,
        "7h2s": -1,
        "7h2h": -1,
        "7h2d": -1,
        "7h2c": -1,
        "7d7c": 2,
        "7d6s": -1,
        "7d6h": -1,
        "7d6d": -1,
        "7d6c": -1,
        "7d5s": -1,
        "7d5h": -1,
        "7d5d": -1,
        "7d5c": -1,
        "7d4s": -1,
        "7d4h": -1,
        "7d4d": -1,
        "7d4c": -1,
        "7d3s": -1,
        "7d3h": -1,
        "7d3d": -1,
        "7d3c": -1,
        "7d2s": -1,
        "7d2h": -1,
        "7d2d": -1,
        "7d2c": -1,
        "7c6s": -1,
        "7c6h": -1,
        "7c6d": -1,
        "7c6c": -1,
        "7c5s": -1,
        "7c5h": -1,
        "7c5d": -1,
        "7c5c": -1,
        "7c4s": -1,
        "7c4h": -1,
        "7c4d": -1,
        "7c4c": -1,
        "7c3s": -1,
        "7c3h": -1,
        "7c3d": -1,
        "7c3c": -1,
        "7c2s": -1,
        "7c2h": -1,
        "7c2d": -1,
        "7c2c": -1,
        "6s6h": 2,
        "6s6d": 2,
        "6s6c": 2,
        "6s5s": -1,
        "6s5h": -1,
        "6s5d": -1,
        "6s5c": -1,
        "6s4s": -1,
        "6s4h": -1,
        "6s4d": -1,
        "6s4c": -1,
        "6s3s": -1,
        "6s3h": -1,
        "6s3d": -1,
        "6s3c": -1,
        "6s2s": -1,
        "6s2h": -1,
        "6s2d": -1,
        "6s2c": -1,
        "6h6d": 2,
        "6h6c": 2,
        "6h5s": -1,
        "6h5h": -1,
        "6h5d": -1,
        "6h5c": -1,
        "6h4s": -1,
        "6h4h": -1,
        "6h4d": -1,
        "6h4c": -1,
        "6h3s": -1,
        "6h3h": -1,
        "6h3d": -1,
        "6h3c": -1,
        "6h2s": -1,
        "6h2h": -1,
        "6h2d": -1,
        "6h2c": -1,
        "6d6c": 2,
        "6d5s": -1,
        "6d5h": -1,
        "6d5d": -1,
        "6d5c": -1,
        "6d4s": -1,
        "6d4h": -1,
        "6d4d": -1,
        "6d4c": -1,
        "6d3s": -1,
        "6d3h": -1,
        "6d3d": -1,
        "6d3c": -1,
        "6d2s": -1,
        "6d2h": -1,
        "6d2d": -1,
        "6d2c": -1,
        "6c5s": -1,
        "6c5h": -1,
        "6c5d": -1,
        "6c5c": -1,
        "6c4s": -1,
        "6c4h": -1,
        "6c4d": -1,
        "6c4c": -1,
        "6c3s": -1,
        "6c3h": -1,
        "6c3d": -1,
        "6c3c": -1,
        "6c2s": -1,
        "6c2h": -1,
        "6c2d": -1,
        "6c2c": -1,
        "5s5h": 0,
        "5s5d": 0,
        "5s5c": 0,
        "5s4s": -1,
        "5s4h": -1,
        "5s4d": -1,
        "5s4c": -1,
        "5s3s": -1,
        "5s3h": -1,
        "5s3d": -1,
        "5s3c": -1,
        "5s2s": -1,
        "5s2h": -1,
        "5s2d": -1,
        "5s2c": -1,
        "5h5d": 0,
        "5h5c": 0,
        "5h4s": -1,
        "5h4h": -1,
        "5h4d": -1,
        "5h4c": -1,
        "5h3s": -1,
        "5h3h": -1,
        "5h3d": -1,
        "5h3c": -1,
        "5h2s": -1,
        "5h2h": -1,
        "5h2d": -1,
        "5h2c": -1,
        "5d5c": 0,
        "5d4s": -1,
        "5d4h": -1,
        "5d4d": -1,
        "5d4c": -1,
        "5d3s": -1,
        "5d3h": -1,
        "5d3d": -1,
        "5d3c": -1,
        "5d2s": -1,
        "5d2h": -1,
        "5d2d": -1,
        "5d2c": -1,
        "5c4s": -1,
        "5c4h": -1,
        "5c4d": -1,
        "5c4c": -1,
        "5c3s": -1,
        "5c3h": -1,
        "5c3d": -1,
        "5c3c": -1,
        "5c2s": -1,
        "5c2h": -1,
        "5c2d": -1,
        "5c2c": -1,
        "4s4h": 2,
        "4s4d": 2,
        "4s4c": 2,
        "4s3s": -1,
        "4s3h": -1,
        "4s3d": -1,
        "4s3c": -1,
        "4s2s": -1,
        "4s2h": -1,
        "4s2d": -1,
        "4s2c": -1,
        "4h4d": 2,
        "4h4c": 2,
        "4h3s": -1,
        "4h3h": -1,
        "4h3d": -1,
        "4h3c": -1,
        "4h2s": -1,
        "4h2h": -1,
        "4h2d": -1,
        "4h2c": -1,
        "4d4c": 2,
        "4d3s": -1,
        "4d3h": -1,
        "4d3d": -1,
        "4d3c": -1,
        "4d2s": -1,
        "4d2h": -1,
        "4d2d": -1,
        "4d2c": -1,
        "4c3s": -1,
        "4c3h": -1,
        "4c3d": -1,
        "4c3c": -1,
        "4c2s": -1,
        "4c2h": -1,
        "4c2d": -1,
        "4c2c": -1,
        "3s3h": -1,
        "3s3d": -1,
        "3s3c": -1,
        "3s2s": -1,
        "3s2h": -1,
        "3s2d": -1,
        "3s2c": -1,
        "3h3d": -1,
        "3h3c": -1,
        "3h2s": -1,
        "3h2h": -1,
        "3h2d": -1,
        "3h2c": -1,
        "3d3c": -1,
        "3d2s": -1,
        "3d2h": -1,
        "3d2d": -1,
        "3d2c": -1,
        "3c2s": -1,
        "3c2h": -1,
        "3c2d": -1,
        "3c2c": -1,
        "2s2h": -1,
        "2s2d": -1,
        "2s2c": -1,
        "2h2d": -1,
        "2h2c": -1,
        "2d2c": -1,
      },
      fixedCards: 0,
    },
    id: 1,
    action: "Bet",
  },
  {
    text: "Turn",
    snapshot: {
      board: ["8c", "5d", "3s", "Ad"],
      notes: "",
      activeActionSetId: "postflopAggressor",
      activeColorSchemeId: "default",
      subrangeByComboString: {
        AsAh: -1,
        AsAd: -1,
        AsAc: -1,
        AsKs: -1,
        AsKh: -1,
        AsKd: -1,
        AsKc: -1,
        AsQs: -1,
        AsQh: -1,
        AsQd: -1,
        AsQc: -1,
        AsJs: -1,
        AsJh: -1,
        AsJd: -1,
        AsJc: -1,
        AsTs: 2,
        AsTh: -1,
        AsTd: -1,
        AsTc: -1,
        As9s: -1,
        As9h: -1,
        As9d: -1,
        As9c: -1,
        As8s: -1,
        As8h: -1,
        As8d: -1,
        As8c: -1,
        As7s: -1,
        As7h: -1,
        As7d: -1,
        As7c: -1,
        As6s: -1,
        As6h: -1,
        As6d: -1,
        As6c: -1,
        As5s: -1,
        As5h: -1,
        As5d: -1,
        As5c: -1,
        As4s: -1,
        As4h: -1,
        As4d: -1,
        As4c: -1,
        As3s: -1,
        As3h: -1,
        As3d: -1,
        As3c: -1,
        As2s: -1,
        As2h: -1,
        As2d: -1,
        As2c: -1,
        AhAd: -1,
        AhAc: -1,
        AhKs: -1,
        AhKh: -1,
        AhKd: -1,
        AhKc: -1,
        AhQs: -1,
        AhQh: -1,
        AhQd: -1,
        AhQc: -1,
        AhJs: -1,
        AhJh: -1,
        AhJd: -1,
        AhJc: -1,
        AhTs: -1,
        AhTh: -1,
        AhTd: -1,
        AhTc: -1,
        Ah9s: -1,
        Ah9h: -1,
        Ah9d: -1,
        Ah9c: -1,
        Ah8s: -1,
        Ah8h: -1,
        Ah8d: -1,
        Ah8c: -1,
        Ah7s: -1,
        Ah7h: -1,
        Ah7d: -1,
        Ah7c: -1,
        Ah6s: -1,
        Ah6h: -1,
        Ah6d: -1,
        Ah6c: -1,
        Ah5s: -1,
        Ah5h: -1,
        Ah5d: -1,
        Ah5c: -1,
        Ah4s: -1,
        Ah4h: -1,
        Ah4d: -1,
        Ah4c: -1,
        Ah3s: -1,
        Ah3h: -1,
        Ah3d: -1,
        Ah3c: -1,
        Ah2s: -1,
        Ah2h: -1,
        Ah2d: -1,
        Ah2c: -1,
        AdAc: -1,
        AdKs: -1,
        AdKh: -1,
        AdKd: -1,
        AdKc: -1,
        AdQs: -1,
        AdQh: -1,
        AdQd: -1,
        AdQc: -1,
        AdJs: -1,
        AdJh: -1,
        AdJd: -1,
        AdJc: -1,
        AdTs: -1,
        AdTh: -1,
        AdTd: 2,
        AdTc: -1,
        Ad9s: -1,
        Ad9h: -1,
        Ad9d: -1,
        Ad9c: -1,
        Ad8s: -1,
        Ad8h: -1,
        Ad8d: -1,
        Ad8c: -1,
        Ad7s: -1,
        Ad7h: -1,
        Ad7d: -1,
        Ad7c: -1,
        Ad6s: -1,
        Ad6h: -1,
        Ad6d: -1,
        Ad6c: -1,
        Ad5s: -1,
        Ad5h: -1,
        Ad5d: -1,
        Ad5c: -1,
        Ad4s: -1,
        Ad4h: -1,
        Ad4d: -1,
        Ad4c: -1,
        Ad3s: -1,
        Ad3h: -1,
        Ad3d: -1,
        Ad3c: -1,
        Ad2s: -1,
        Ad2h: -1,
        Ad2d: -1,
        Ad2c: -1,
        AcKs: -1,
        AcKh: -1,
        AcKd: -1,
        AcKc: -1,
        AcQs: -1,
        AcQh: -1,
        AcQd: -1,
        AcQc: -1,
        AcJs: -1,
        AcJh: -1,
        AcJd: -1,
        AcJc: -1,
        AcTs: -1,
        AcTh: -1,
        AcTd: -1,
        AcTc: 2,
        Ac9s: -1,
        Ac9h: -1,
        Ac9d: -1,
        Ac9c: -1,
        Ac8s: -1,
        Ac8h: -1,
        Ac8d: -1,
        Ac8c: -1,
        Ac7s: -1,
        Ac7h: -1,
        Ac7d: -1,
        Ac7c: -1,
        Ac6s: -1,
        Ac6h: -1,
        Ac6d: -1,
        Ac6c: -1,
        Ac5s: -1,
        Ac5h: -1,
        Ac5d: -1,
        Ac5c: -1,
        Ac4s: -1,
        Ac4h: -1,
        Ac4d: -1,
        Ac4c: -1,
        Ac3s: -1,
        Ac3h: -1,
        Ac3d: -1,
        Ac3c: -1,
        Ac2s: -1,
        Ac2h: -1,
        Ac2d: -1,
        Ac2c: -1,
        KsKh: -1,
        KsKd: -1,
        KsKc: -1,
        KsQs: 3,
        KsQh: -1,
        KsQd: -1,
        KsQc: -1,
        KsJs: 3,
        KsJh: -1,
        KsJd: -1,
        KsJc: -1,
        KsTs: 3,
        KsTh: -1,
        KsTd: -1,
        KsTc: -1,
        Ks9s: -1,
        Ks9h: -1,
        Ks9d: -1,
        Ks9c: -1,
        Ks8s: -1,
        Ks8h: -1,
        Ks8d: -1,
        Ks8c: -1,
        Ks7s: -1,
        Ks7h: -1,
        Ks7d: -1,
        Ks7c: -1,
        Ks6s: -1,
        Ks6h: -1,
        Ks6d: -1,
        Ks6c: -1,
        Ks5s: -1,
        Ks5h: -1,
        Ks5d: -1,
        Ks5c: -1,
        Ks4s: -1,
        Ks4h: -1,
        Ks4d: -1,
        Ks4c: -1,
        Ks3s: -1,
        Ks3h: -1,
        Ks3d: -1,
        Ks3c: -1,
        Ks2s: -1,
        Ks2h: -1,
        Ks2d: -1,
        Ks2c: -1,
        KhKd: -1,
        KhKc: -1,
        KhQs: -1,
        KhQh: -1,
        KhQd: -1,
        KhQc: -1,
        KhJs: -1,
        KhJh: -1,
        KhJd: -1,
        KhJc: -1,
        KhTs: -1,
        KhTh: -1,
        KhTd: -1,
        KhTc: -1,
        Kh9s: -1,
        Kh9h: -1,
        Kh9d: -1,
        Kh9c: -1,
        Kh8s: -1,
        Kh8h: -1,
        Kh8d: -1,
        Kh8c: -1,
        Kh7s: -1,
        Kh7h: -1,
        Kh7d: -1,
        Kh7c: -1,
        Kh6s: -1,
        Kh6h: -1,
        Kh6d: -1,
        Kh6c: -1,
        Kh5s: -1,
        Kh5h: -1,
        Kh5d: -1,
        Kh5c: -1,
        Kh4s: -1,
        Kh4h: -1,
        Kh4d: -1,
        Kh4c: -1,
        Kh3s: -1,
        Kh3h: -1,
        Kh3d: -1,
        Kh3c: -1,
        Kh2s: -1,
        Kh2h: -1,
        Kh2d: -1,
        Kh2c: -1,
        KdKc: -1,
        KdQs: -1,
        KdQh: -1,
        KdQd: 1,
        KdQc: -1,
        KdJs: -1,
        KdJh: -1,
        KdJd: 1,
        KdJc: -1,
        KdTs: -1,
        KdTh: -1,
        KdTd: 1,
        KdTc: -1,
        Kd9s: -1,
        Kd9h: -1,
        Kd9d: -1,
        Kd9c: -1,
        Kd8s: -1,
        Kd8h: -1,
        Kd8d: -1,
        Kd8c: -1,
        Kd7s: -1,
        Kd7h: -1,
        Kd7d: -1,
        Kd7c: -1,
        Kd6s: -1,
        Kd6h: -1,
        Kd6d: -1,
        Kd6c: -1,
        Kd5s: -1,
        Kd5h: -1,
        Kd5d: -1,
        Kd5c: -1,
        Kd4s: -1,
        Kd4h: -1,
        Kd4d: -1,
        Kd4c: -1,
        Kd3s: -1,
        Kd3h: -1,
        Kd3d: -1,
        Kd3c: -1,
        Kd2s: -1,
        Kd2h: -1,
        Kd2d: -1,
        Kd2c: -1,
        KcQs: -1,
        KcQh: -1,
        KcQd: -1,
        KcQc: 3,
        KcJs: -1,
        KcJh: -1,
        KcJd: -1,
        KcJc: 3,
        KcTs: -1,
        KcTh: -1,
        KcTd: -1,
        KcTc: 3,
        Kc9s: -1,
        Kc9h: -1,
        Kc9d: -1,
        Kc9c: -1,
        Kc8s: -1,
        Kc8h: -1,
        Kc8d: -1,
        Kc8c: -1,
        Kc7s: -1,
        Kc7h: -1,
        Kc7d: -1,
        Kc7c: -1,
        Kc6s: -1,
        Kc6h: -1,
        Kc6d: -1,
        Kc6c: -1,
        Kc5s: -1,
        Kc5h: -1,
        Kc5d: -1,
        Kc5c: -1,
        Kc4s: -1,
        Kc4h: -1,
        Kc4d: -1,
        Kc4c: -1,
        Kc3s: -1,
        Kc3h: -1,
        Kc3d: -1,
        Kc3c: -1,
        Kc2s: -1,
        Kc2h: -1,
        Kc2d: -1,
        Kc2c: -1,
        QsQh: -1,
        QsQd: -1,
        QsQc: -1,
        QsJs: -1,
        QsJh: -1,
        QsJd: -1,
        QsJc: -1,
        QsTs: 3,
        QsTh: -1,
        QsTd: -1,
        QsTc: -1,
        Qs9s: -1,
        Qs9h: -1,
        Qs9d: -1,
        Qs9c: -1,
        Qs8s: -1,
        Qs8h: -1,
        Qs8d: -1,
        Qs8c: -1,
        Qs7s: -1,
        Qs7h: -1,
        Qs7d: -1,
        Qs7c: -1,
        Qs6s: -1,
        Qs6h: -1,
        Qs6d: -1,
        Qs6c: -1,
        Qs5s: -1,
        Qs5h: -1,
        Qs5d: -1,
        Qs5c: -1,
        Qs4s: -1,
        Qs4h: -1,
        Qs4d: -1,
        Qs4c: -1,
        Qs3s: -1,
        Qs3h: -1,
        Qs3d: -1,
        Qs3c: -1,
        Qs2s: -1,
        Qs2h: -1,
        Qs2d: -1,
        Qs2c: -1,
        QhQd: -1,
        QhQc: -1,
        QhJs: -1,
        QhJh: -1,
        QhJd: -1,
        QhJc: -1,
        QhTs: -1,
        QhTh: 3,
        QhTd: -1,
        QhTc: -1,
        Qh9s: -1,
        Qh9h: -1,
        Qh9d: -1,
        Qh9c: -1,
        Qh8s: -1,
        Qh8h: -1,
        Qh8d: -1,
        Qh8c: -1,
        Qh7s: -1,
        Qh7h: -1,
        Qh7d: -1,
        Qh7c: -1,
        Qh6s: -1,
        Qh6h: -1,
        Qh6d: -1,
        Qh6c: -1,
        Qh5s: -1,
        Qh5h: -1,
        Qh5d: -1,
        Qh5c: -1,
        Qh4s: -1,
        Qh4h: -1,
        Qh4d: -1,
        Qh4c: -1,
        Qh3s: -1,
        Qh3h: -1,
        Qh3d: -1,
        Qh3c: -1,
        Qh2s: -1,
        Qh2h: -1,
        Qh2d: -1,
        Qh2c: -1,
        QdQc: -1,
        QdJs: -1,
        QdJh: -1,
        QdJd: -1,
        QdJc: -1,
        QdTs: -1,
        QdTh: -1,
        QdTd: 1,
        QdTc: -1,
        Qd9s: -1,
        Qd9h: -1,
        Qd9d: -1,
        Qd9c: -1,
        Qd8s: -1,
        Qd8h: -1,
        Qd8d: -1,
        Qd8c: -1,
        Qd7s: -1,
        Qd7h: -1,
        Qd7d: -1,
        Qd7c: -1,
        Qd6s: -1,
        Qd6h: -1,
        Qd6d: -1,
        Qd6c: -1,
        Qd5s: -1,
        Qd5h: -1,
        Qd5d: -1,
        Qd5c: -1,
        Qd4s: -1,
        Qd4h: -1,
        Qd4d: -1,
        Qd4c: -1,
        Qd3s: -1,
        Qd3h: -1,
        Qd3d: -1,
        Qd3c: -1,
        Qd2s: -1,
        Qd2h: -1,
        Qd2d: -1,
        Qd2c: -1,
        QcJs: -1,
        QcJh: -1,
        QcJd: -1,
        QcJc: -1,
        QcTs: -1,
        QcTh: -1,
        QcTd: -1,
        QcTc: 3,
        Qc9s: -1,
        Qc9h: -1,
        Qc9d: -1,
        Qc9c: -1,
        Qc8s: -1,
        Qc8h: -1,
        Qc8d: -1,
        Qc8c: -1,
        Qc7s: -1,
        Qc7h: -1,
        Qc7d: -1,
        Qc7c: -1,
        Qc6s: -1,
        Qc6h: -1,
        Qc6d: -1,
        Qc6c: -1,
        Qc5s: -1,
        Qc5h: -1,
        Qc5d: -1,
        Qc5c: -1,
        Qc4s: -1,
        Qc4h: -1,
        Qc4d: -1,
        Qc4c: -1,
        Qc3s: -1,
        Qc3h: -1,
        Qc3d: -1,
        Qc3c: -1,
        Qc2s: -1,
        Qc2h: -1,
        Qc2d: -1,
        Qc2c: -1,
        JsJh: -1,
        JsJd: -1,
        JsJc: -1,
        JsTs: 3,
        JsTh: -1,
        JsTd: -1,
        JsTc: -1,
        Js9s: -1,
        Js9h: -1,
        Js9d: -1,
        Js9c: -1,
        Js8s: -1,
        Js8h: -1,
        Js8d: -1,
        Js8c: -1,
        Js7s: -1,
        Js7h: -1,
        Js7d: -1,
        Js7c: -1,
        Js6s: -1,
        Js6h: -1,
        Js6d: -1,
        Js6c: -1,
        Js5s: -1,
        Js5h: -1,
        Js5d: -1,
        Js5c: -1,
        Js4s: -1,
        Js4h: -1,
        Js4d: -1,
        Js4c: -1,
        Js3s: -1,
        Js3h: -1,
        Js3d: -1,
        Js3c: -1,
        Js2s: -1,
        Js2h: -1,
        Js2d: -1,
        Js2c: -1,
        JhJd: -1,
        JhJc: -1,
        JhTs: -1,
        JhTh: 3,
        JhTd: -1,
        JhTc: -1,
        Jh9s: -1,
        Jh9h: -1,
        Jh9d: -1,
        Jh9c: -1,
        Jh8s: -1,
        Jh8h: -1,
        Jh8d: -1,
        Jh8c: -1,
        Jh7s: -1,
        Jh7h: -1,
        Jh7d: -1,
        Jh7c: -1,
        Jh6s: -1,
        Jh6h: -1,
        Jh6d: -1,
        Jh6c: -1,
        Jh5s: -1,
        Jh5h: -1,
        Jh5d: -1,
        Jh5c: -1,
        Jh4s: -1,
        Jh4h: -1,
        Jh4d: -1,
        Jh4c: -1,
        Jh3s: -1,
        Jh3h: -1,
        Jh3d: -1,
        Jh3c: -1,
        Jh2s: -1,
        Jh2h: -1,
        Jh2d: -1,
        Jh2c: -1,
        JdJc: -1,
        JdTs: -1,
        JdTh: -1,
        JdTd: 1,
        JdTc: -1,
        Jd9s: -1,
        Jd9h: -1,
        Jd9d: -1,
        Jd9c: -1,
        Jd8s: -1,
        Jd8h: -1,
        Jd8d: -1,
        Jd8c: -1,
        Jd7s: -1,
        Jd7h: -1,
        Jd7d: -1,
        Jd7c: -1,
        Jd6s: -1,
        Jd6h: -1,
        Jd6d: -1,
        Jd6c: -1,
        Jd5s: -1,
        Jd5h: -1,
        Jd5d: -1,
        Jd5c: -1,
        Jd4s: -1,
        Jd4h: -1,
        Jd4d: -1,
        Jd4c: -1,
        Jd3s: -1,
        Jd3h: -1,
        Jd3d: -1,
        Jd3c: -1,
        Jd2s: -1,
        Jd2h: -1,
        Jd2d: -1,
        Jd2c: -1,
        JcTs: -1,
        JcTh: -1,
        JcTd: -1,
        JcTc: 3,
        Jc9s: -1,
        Jc9h: -1,
        Jc9d: -1,
        Jc9c: -1,
        Jc8s: -1,
        Jc8h: -1,
        Jc8d: -1,
        Jc8c: -1,
        Jc7s: -1,
        Jc7h: -1,
        Jc7d: -1,
        Jc7c: -1,
        Jc6s: -1,
        Jc6h: -1,
        Jc6d: -1,
        Jc6c: -1,
        Jc5s: -1,
        Jc5h: -1,
        Jc5d: -1,
        Jc5c: -1,
        Jc4s: -1,
        Jc4h: -1,
        Jc4d: -1,
        Jc4c: -1,
        Jc3s: -1,
        Jc3h: -1,
        Jc3d: -1,
        Jc3c: -1,
        Jc2s: -1,
        Jc2h: -1,
        Jc2d: -1,
        Jc2c: -1,
        TsTh: 2,
        TsTd: 2,
        TsTc: 2,
        Ts9s: 3,
        Ts9h: -1,
        Ts9d: -1,
        Ts9c: -1,
        Ts8s: -1,
        Ts8h: -1,
        Ts8d: -1,
        Ts8c: -1,
        Ts7s: -1,
        Ts7h: -1,
        Ts7d: -1,
        Ts7c: -1,
        Ts6s: -1,
        Ts6h: -1,
        Ts6d: -1,
        Ts6c: -1,
        Ts5s: -1,
        Ts5h: -1,
        Ts5d: -1,
        Ts5c: -1,
        Ts4s: -1,
        Ts4h: -1,
        Ts4d: -1,
        Ts4c: -1,
        Ts3s: -1,
        Ts3h: -1,
        Ts3d: -1,
        Ts3c: -1,
        Ts2s: -1,
        Ts2h: -1,
        Ts2d: -1,
        Ts2c: -1,
        ThTd: 2,
        ThTc: 2,
        Th9s: -1,
        Th9h: 3,
        Th9d: -1,
        Th9c: -1,
        Th8s: -1,
        Th8h: -1,
        Th8d: -1,
        Th8c: -1,
        Th7s: -1,
        Th7h: -1,
        Th7d: -1,
        Th7c: -1,
        Th6s: -1,
        Th6h: -1,
        Th6d: -1,
        Th6c: -1,
        Th5s: -1,
        Th5h: -1,
        Th5d: -1,
        Th5c: -1,
        Th4s: -1,
        Th4h: -1,
        Th4d: -1,
        Th4c: -1,
        Th3s: -1,
        Th3h: -1,
        Th3d: -1,
        Th3c: -1,
        Th2s: -1,
        Th2h: -1,
        Th2d: -1,
        Th2c: -1,
        TdTc: 2,
        Td9s: -1,
        Td9h: -1,
        Td9d: 1,
        Td9c: -1,
        Td8s: -1,
        Td8h: -1,
        Td8d: -1,
        Td8c: -1,
        Td7s: -1,
        Td7h: -1,
        Td7d: -1,
        Td7c: -1,
        Td6s: -1,
        Td6h: -1,
        Td6d: -1,
        Td6c: -1,
        Td5s: -1,
        Td5h: -1,
        Td5d: -1,
        Td5c: -1,
        Td4s: -1,
        Td4h: -1,
        Td4d: -1,
        Td4c: -1,
        Td3s: -1,
        Td3h: -1,
        Td3d: -1,
        Td3c: -1,
        Td2s: -1,
        Td2h: -1,
        Td2d: -1,
        Td2c: -1,
        Tc9s: -1,
        Tc9h: -1,
        Tc9d: -1,
        Tc9c: 3,
        Tc8s: -1,
        Tc8h: -1,
        Tc8d: -1,
        Tc8c: -1,
        Tc7s: -1,
        Tc7h: -1,
        Tc7d: -1,
        Tc7c: -1,
        Tc6s: -1,
        Tc6h: -1,
        Tc6d: -1,
        Tc6c: -1,
        Tc5s: -1,
        Tc5h: -1,
        Tc5d: -1,
        Tc5c: -1,
        Tc4s: -1,
        Tc4h: -1,
        Tc4d: -1,
        Tc4c: -1,
        Tc3s: -1,
        Tc3h: -1,
        Tc3d: -1,
        Tc3c: -1,
        Tc2s: -1,
        Tc2h: -1,
        Tc2d: -1,
        Tc2c: -1,
        "9s9h": 2,
        "9s9d": 2,
        "9s9c": 2,
        "9s8s": 2,
        "9s8h": -1,
        "9s8d": -1,
        "9s8c": -1,
        "9s7s": -1,
        "9s7h": -1,
        "9s7d": -1,
        "9s7c": -1,
        "9s6s": -1,
        "9s6h": -1,
        "9s6d": -1,
        "9s6c": -1,
        "9s5s": -1,
        "9s5h": -1,
        "9s5d": -1,
        "9s5c": -1,
        "9s4s": -1,
        "9s4h": -1,
        "9s4d": -1,
        "9s4c": -1,
        "9s3s": -1,
        "9s3h": -1,
        "9s3d": -1,
        "9s3c": -1,
        "9s2s": -1,
        "9s2h": -1,
        "9s2d": -1,
        "9s2c": -1,
        "9h9d": 2,
        "9h9c": 2,
        "9h8s": -1,
        "9h8h": 2,
        "9h8d": -1,
        "9h8c": -1,
        "9h7s": -1,
        "9h7h": -1,
        "9h7d": -1,
        "9h7c": -1,
        "9h6s": -1,
        "9h6h": -1,
        "9h6d": -1,
        "9h6c": -1,
        "9h5s": -1,
        "9h5h": -1,
        "9h5d": -1,
        "9h5c": -1,
        "9h4s": -1,
        "9h4h": -1,
        "9h4d": -1,
        "9h4c": -1,
        "9h3s": -1,
        "9h3h": -1,
        "9h3d": -1,
        "9h3c": -1,
        "9h2s": -1,
        "9h2h": -1,
        "9h2d": -1,
        "9h2c": -1,
        "9d9c": 2,
        "9d8s": -1,
        "9d8h": -1,
        "9d8d": 2,
        "9d8c": -1,
        "9d7s": -1,
        "9d7h": -1,
        "9d7d": -1,
        "9d7c": -1,
        "9d6s": -1,
        "9d6h": -1,
        "9d6d": -1,
        "9d6c": -1,
        "9d5s": -1,
        "9d5h": -1,
        "9d5d": -1,
        "9d5c": -1,
        "9d4s": -1,
        "9d4h": -1,
        "9d4d": -1,
        "9d4c": -1,
        "9d3s": -1,
        "9d3h": -1,
        "9d3d": -1,
        "9d3c": -1,
        "9d2s": -1,
        "9d2h": -1,
        "9d2d": -1,
        "9d2c": -1,
        "9c8s": -1,
        "9c8h": -1,
        "9c8d": -1,
        "9c8c": 2,
        "9c7s": -1,
        "9c7h": -1,
        "9c7d": -1,
        "9c7c": -1,
        "9c6s": -1,
        "9c6h": -1,
        "9c6d": -1,
        "9c6c": -1,
        "9c5s": -1,
        "9c5h": -1,
        "9c5d": -1,
        "9c5c": -1,
        "9c4s": -1,
        "9c4h": -1,
        "9c4d": -1,
        "9c4c": -1,
        "9c3s": -1,
        "9c3h": -1,
        "9c3d": -1,
        "9c3c": -1,
        "9c2s": -1,
        "9c2h": -1,
        "9c2d": -1,
        "9c2c": -1,
        "8s8h": 0,
        "8s8d": 0,
        "8s8c": 0,
        "8s7s": -1,
        "8s7h": -1,
        "8s7d": -1,
        "8s7c": -1,
        "8s6s": -1,
        "8s6h": -1,
        "8s6d": -1,
        "8s6c": -1,
        "8s5s": -1,
        "8s5h": -1,
        "8s5d": -1,
        "8s5c": -1,
        "8s4s": -1,
        "8s4h": -1,
        "8s4d": -1,
        "8s4c": -1,
        "8s3s": -1,
        "8s3h": -1,
        "8s3d": -1,
        "8s3c": -1,
        "8s2s": -1,
        "8s2h": -1,
        "8s2d": -1,
        "8s2c": -1,
        "8h8d": 0,
        "8h8c": 0,
        "8h7s": -1,
        "8h7h": -1,
        "8h7d": -1,
        "8h7c": -1,
        "8h6s": -1,
        "8h6h": -1,
        "8h6d": -1,
        "8h6c": -1,
        "8h5s": -1,
        "8h5h": -1,
        "8h5d": -1,
        "8h5c": -1,
        "8h4s": -1,
        "8h4h": -1,
        "8h4d": -1,
        "8h4c": -1,
        "8h3s": -1,
        "8h3h": -1,
        "8h3d": -1,
        "8h3c": -1,
        "8h2s": -1,
        "8h2h": -1,
        "8h2d": -1,
        "8h2c": -1,
        "8d8c": 0,
        "8d7s": -1,
        "8d7h": -1,
        "8d7d": -1,
        "8d7c": -1,
        "8d6s": -1,
        "8d6h": -1,
        "8d6d": -1,
        "8d6c": -1,
        "8d5s": -1,
        "8d5h": -1,
        "8d5d": -1,
        "8d5c": -1,
        "8d4s": -1,
        "8d4h": -1,
        "8d4d": -1,
        "8d4c": -1,
        "8d3s": -1,
        "8d3h": -1,
        "8d3d": -1,
        "8d3c": -1,
        "8d2s": -1,
        "8d2h": -1,
        "8d2d": -1,
        "8d2c": -1,
        "8c7s": -1,
        "8c7h": -1,
        "8c7d": -1,
        "8c7c": -1,
        "8c6s": -1,
        "8c6h": -1,
        "8c6d": -1,
        "8c6c": -1,
        "8c5s": -1,
        "8c5h": -1,
        "8c5d": -1,
        "8c5c": -1,
        "8c4s": -1,
        "8c4h": -1,
        "8c4d": -1,
        "8c4c": -1,
        "8c3s": -1,
        "8c3h": -1,
        "8c3d": -1,
        "8c3c": -1,
        "8c2s": -1,
        "8c2h": -1,
        "8c2d": -1,
        "8c2c": -1,
        "7s7h": -1,
        "7s7d": -1,
        "7s7c": -1,
        "7s6s": -1,
        "7s6h": -1,
        "7s6d": -1,
        "7s6c": -1,
        "7s5s": -1,
        "7s5h": -1,
        "7s5d": -1,
        "7s5c": -1,
        "7s4s": -1,
        "7s4h": -1,
        "7s4d": -1,
        "7s4c": -1,
        "7s3s": -1,
        "7s3h": -1,
        "7s3d": -1,
        "7s3c": -1,
        "7s2s": -1,
        "7s2h": -1,
        "7s2d": -1,
        "7s2c": -1,
        "7h7d": -1,
        "7h7c": -1,
        "7h6s": -1,
        "7h6h": -1,
        "7h6d": -1,
        "7h6c": -1,
        "7h5s": -1,
        "7h5h": -1,
        "7h5d": -1,
        "7h5c": -1,
        "7h4s": -1,
        "7h4h": -1,
        "7h4d": -1,
        "7h4c": -1,
        "7h3s": -1,
        "7h3h": -1,
        "7h3d": -1,
        "7h3c": -1,
        "7h2s": -1,
        "7h2h": -1,
        "7h2d": -1,
        "7h2c": -1,
        "7d7c": -1,
        "7d6s": -1,
        "7d6h": -1,
        "7d6d": -1,
        "7d6c": -1,
        "7d5s": -1,
        "7d5h": -1,
        "7d5d": -1,
        "7d5c": -1,
        "7d4s": -1,
        "7d4h": -1,
        "7d4d": -1,
        "7d4c": -1,
        "7d3s": -1,
        "7d3h": -1,
        "7d3d": -1,
        "7d3c": -1,
        "7d2s": -1,
        "7d2h": -1,
        "7d2d": -1,
        "7d2c": -1,
        "7c6s": -1,
        "7c6h": -1,
        "7c6d": -1,
        "7c6c": -1,
        "7c5s": -1,
        "7c5h": -1,
        "7c5d": -1,
        "7c5c": -1,
        "7c4s": -1,
        "7c4h": -1,
        "7c4d": -1,
        "7c4c": -1,
        "7c3s": -1,
        "7c3h": -1,
        "7c3d": -1,
        "7c3c": -1,
        "7c2s": -1,
        "7c2h": -1,
        "7c2d": -1,
        "7c2c": -1,
        "6s6h": -1,
        "6s6d": -1,
        "6s6c": -1,
        "6s5s": -1,
        "6s5h": -1,
        "6s5d": -1,
        "6s5c": -1,
        "6s4s": -1,
        "6s4h": -1,
        "6s4d": -1,
        "6s4c": -1,
        "6s3s": -1,
        "6s3h": -1,
        "6s3d": -1,
        "6s3c": -1,
        "6s2s": -1,
        "6s2h": -1,
        "6s2d": -1,
        "6s2c": -1,
        "6h6d": -1,
        "6h6c": -1,
        "6h5s": -1,
        "6h5h": -1,
        "6h5d": -1,
        "6h5c": -1,
        "6h4s": -1,
        "6h4h": -1,
        "6h4d": -1,
        "6h4c": -1,
        "6h3s": -1,
        "6h3h": -1,
        "6h3d": -1,
        "6h3c": -1,
        "6h2s": -1,
        "6h2h": -1,
        "6h2d": -1,
        "6h2c": -1,
        "6d6c": -1,
        "6d5s": -1,
        "6d5h": -1,
        "6d5d": -1,
        "6d5c": -1,
        "6d4s": -1,
        "6d4h": -1,
        "6d4d": -1,
        "6d4c": -1,
        "6d3s": -1,
        "6d3h": -1,
        "6d3d": -1,
        "6d3c": -1,
        "6d2s": -1,
        "6d2h": -1,
        "6d2d": -1,
        "6d2c": -1,
        "6c5s": -1,
        "6c5h": -1,
        "6c5d": -1,
        "6c5c": -1,
        "6c4s": -1,
        "6c4h": -1,
        "6c4d": -1,
        "6c4c": -1,
        "6c3s": -1,
        "6c3h": -1,
        "6c3d": -1,
        "6c3c": -1,
        "6c2s": -1,
        "6c2h": -1,
        "6c2d": -1,
        "6c2c": -1,
        "5s5h": 0,
        "5s5d": 0,
        "5s5c": 0,
        "5s4s": -1,
        "5s4h": -1,
        "5s4d": -1,
        "5s4c": -1,
        "5s3s": -1,
        "5s3h": -1,
        "5s3d": -1,
        "5s3c": -1,
        "5s2s": -1,
        "5s2h": -1,
        "5s2d": -1,
        "5s2c": -1,
        "5h5d": 0,
        "5h5c": 0,
        "5h4s": -1,
        "5h4h": -1,
        "5h4d": -1,
        "5h4c": -1,
        "5h3s": -1,
        "5h3h": -1,
        "5h3d": -1,
        "5h3c": -1,
        "5h2s": -1,
        "5h2h": -1,
        "5h2d": -1,
        "5h2c": -1,
        "5d5c": 0,
        "5d4s": -1,
        "5d4h": -1,
        "5d4d": -1,
        "5d4c": -1,
        "5d3s": -1,
        "5d3h": -1,
        "5d3d": -1,
        "5d3c": -1,
        "5d2s": -1,
        "5d2h": -1,
        "5d2d": -1,
        "5d2c": -1,
        "5c4s": -1,
        "5c4h": -1,
        "5c4d": -1,
        "5c4c": -1,
        "5c3s": -1,
        "5c3h": -1,
        "5c3d": -1,
        "5c3c": -1,
        "5c2s": -1,
        "5c2h": -1,
        "5c2d": -1,
        "5c2c": -1,
        "4s4h": -1,
        "4s4d": -1,
        "4s4c": -1,
        "4s3s": -1,
        "4s3h": -1,
        "4s3d": -1,
        "4s3c": -1,
        "4s2s": -1,
        "4s2h": -1,
        "4s2d": -1,
        "4s2c": -1,
        "4h4d": -1,
        "4h4c": -1,
        "4h3s": -1,
        "4h3h": -1,
        "4h3d": -1,
        "4h3c": -1,
        "4h2s": -1,
        "4h2h": -1,
        "4h2d": -1,
        "4h2c": -1,
        "4d4c": -1,
        "4d3s": -1,
        "4d3h": -1,
        "4d3d": -1,
        "4d3c": -1,
        "4d2s": -1,
        "4d2h": -1,
        "4d2d": -1,
        "4d2c": -1,
        "4c3s": -1,
        "4c3h": -1,
        "4c3d": -1,
        "4c3c": -1,
        "4c2s": -1,
        "4c2h": -1,
        "4c2d": -1,
        "4c2c": -1,
        "3s3h": -1,
        "3s3d": -1,
        "3s3c": -1,
        "3s2s": -1,
        "3s2h": -1,
        "3s2d": -1,
        "3s2c": -1,
        "3h3d": -1,
        "3h3c": -1,
        "3h2s": -1,
        "3h2h": -1,
        "3h2d": -1,
        "3h2c": -1,
        "3d3c": -1,
        "3d2s": -1,
        "3d2h": -1,
        "3d2d": -1,
        "3d2c": -1,
        "3c2s": -1,
        "3c2h": -1,
        "3c2d": -1,
        "3c2c": -1,
        "2s2h": -1,
        "2s2d": -1,
        "2s2c": -1,
        "2h2d": -1,
        "2h2c": -1,
        "2d2c": -1,
      },
      fixedCards: 3,
    },
    id: 2,
    action: "Bet",
  },
  {
    text: "Now",
    snapshot: {
      board: ["8c", "5d", "3s", "Ad", "Th"],
      notes: "",
      activeActionSetId: "postflopAggressor",
      activeColorSchemeId: "default",
      subrangeByComboString: {
        AsAh: -1,
        AsAd: -1,
        AsAc: -1,
        AsKs: -1,
        AsKh: -1,
        AsKd: -1,
        AsKc: -1,
        AsQs: -1,
        AsQh: -1,
        AsQd: -1,
        AsQc: -1,
        AsJs: -1,
        AsJh: -1,
        AsJd: -1,
        AsJc: -1,
        AsTs: -1,
        AsTh: -1,
        AsTd: -1,
        AsTc: -1,
        As9s: -1,
        As9h: -1,
        As9d: -1,
        As9c: -1,
        As8s: -1,
        As8h: -1,
        As8d: -1,
        As8c: -1,
        As7s: -1,
        As7h: -1,
        As7d: -1,
        As7c: -1,
        As6s: -1,
        As6h: -1,
        As6d: -1,
        As6c: -1,
        As5s: -1,
        As5h: -1,
        As5d: -1,
        As5c: -1,
        As4s: -1,
        As4h: -1,
        As4d: -1,
        As4c: -1,
        As3s: -1,
        As3h: -1,
        As3d: -1,
        As3c: -1,
        As2s: -1,
        As2h: -1,
        As2d: -1,
        As2c: -1,
        AhAd: -1,
        AhAc: -1,
        AhKs: -1,
        AhKh: -1,
        AhKd: -1,
        AhKc: -1,
        AhQs: -1,
        AhQh: -1,
        AhQd: -1,
        AhQc: -1,
        AhJs: -1,
        AhJh: -1,
        AhJd: -1,
        AhJc: -1,
        AhTs: -1,
        AhTh: -1,
        AhTd: -1,
        AhTc: -1,
        Ah9s: -1,
        Ah9h: -1,
        Ah9d: -1,
        Ah9c: -1,
        Ah8s: -1,
        Ah8h: -1,
        Ah8d: -1,
        Ah8c: -1,
        Ah7s: -1,
        Ah7h: -1,
        Ah7d: -1,
        Ah7c: -1,
        Ah6s: -1,
        Ah6h: -1,
        Ah6d: -1,
        Ah6c: -1,
        Ah5s: -1,
        Ah5h: -1,
        Ah5d: -1,
        Ah5c: -1,
        Ah4s: -1,
        Ah4h: -1,
        Ah4d: -1,
        Ah4c: -1,
        Ah3s: -1,
        Ah3h: -1,
        Ah3d: -1,
        Ah3c: -1,
        Ah2s: -1,
        Ah2h: -1,
        Ah2d: -1,
        Ah2c: -1,
        AdAc: -1,
        AdKs: -1,
        AdKh: -1,
        AdKd: -1,
        AdKc: -1,
        AdQs: -1,
        AdQh: -1,
        AdQd: -1,
        AdQc: -1,
        AdJs: -1,
        AdJh: -1,
        AdJd: -1,
        AdJc: -1,
        AdTs: -1,
        AdTh: -1,
        AdTd: -1,
        AdTc: -1,
        Ad9s: -1,
        Ad9h: -1,
        Ad9d: -1,
        Ad9c: -1,
        Ad8s: -1,
        Ad8h: -1,
        Ad8d: -1,
        Ad8c: -1,
        Ad7s: -1,
        Ad7h: -1,
        Ad7d: -1,
        Ad7c: -1,
        Ad6s: -1,
        Ad6h: -1,
        Ad6d: -1,
        Ad6c: -1,
        Ad5s: -1,
        Ad5h: -1,
        Ad5d: -1,
        Ad5c: -1,
        Ad4s: -1,
        Ad4h: -1,
        Ad4d: -1,
        Ad4c: -1,
        Ad3s: -1,
        Ad3h: -1,
        Ad3d: -1,
        Ad3c: -1,
        Ad2s: -1,
        Ad2h: -1,
        Ad2d: -1,
        Ad2c: -1,
        AcKs: -1,
        AcKh: -1,
        AcKd: -1,
        AcKc: -1,
        AcQs: -1,
        AcQh: -1,
        AcQd: -1,
        AcQc: -1,
        AcJs: -1,
        AcJh: -1,
        AcJd: -1,
        AcJc: -1,
        AcTs: -1,
        AcTh: -1,
        AcTd: -1,
        AcTc: -1,
        Ac9s: -1,
        Ac9h: -1,
        Ac9d: -1,
        Ac9c: -1,
        Ac8s: -1,
        Ac8h: -1,
        Ac8d: -1,
        Ac8c: -1,
        Ac7s: -1,
        Ac7h: -1,
        Ac7d: -1,
        Ac7c: -1,
        Ac6s: -1,
        Ac6h: -1,
        Ac6d: -1,
        Ac6c: -1,
        Ac5s: -1,
        Ac5h: -1,
        Ac5d: -1,
        Ac5c: -1,
        Ac4s: -1,
        Ac4h: -1,
        Ac4d: -1,
        Ac4c: -1,
        Ac3s: -1,
        Ac3h: -1,
        Ac3d: -1,
        Ac3c: -1,
        Ac2s: -1,
        Ac2h: -1,
        Ac2d: -1,
        Ac2c: -1,
        KsKh: -1,
        KsKd: -1,
        KsKc: -1,
        KsQs: -1,
        KsQh: -1,
        KsQd: -1,
        KsQc: -1,
        KsJs: -1,
        KsJh: -1,
        KsJd: -1,
        KsJc: -1,
        KsTs: -1,
        KsTh: -1,
        KsTd: -1,
        KsTc: -1,
        Ks9s: -1,
        Ks9h: -1,
        Ks9d: -1,
        Ks9c: -1,
        Ks8s: -1,
        Ks8h: -1,
        Ks8d: -1,
        Ks8c: -1,
        Ks7s: -1,
        Ks7h: -1,
        Ks7d: -1,
        Ks7c: -1,
        Ks6s: -1,
        Ks6h: -1,
        Ks6d: -1,
        Ks6c: -1,
        Ks5s: -1,
        Ks5h: -1,
        Ks5d: -1,
        Ks5c: -1,
        Ks4s: -1,
        Ks4h: -1,
        Ks4d: -1,
        Ks4c: -1,
        Ks3s: -1,
        Ks3h: -1,
        Ks3d: -1,
        Ks3c: -1,
        Ks2s: -1,
        Ks2h: -1,
        Ks2d: -1,
        Ks2c: -1,
        KhKd: -1,
        KhKc: -1,
        KhQs: -1,
        KhQh: -1,
        KhQd: -1,
        KhQc: -1,
        KhJs: -1,
        KhJh: -1,
        KhJd: -1,
        KhJc: -1,
        KhTs: -1,
        KhTh: -1,
        KhTd: -1,
        KhTc: -1,
        Kh9s: -1,
        Kh9h: -1,
        Kh9d: -1,
        Kh9c: -1,
        Kh8s: -1,
        Kh8h: -1,
        Kh8d: -1,
        Kh8c: -1,
        Kh7s: -1,
        Kh7h: -1,
        Kh7d: -1,
        Kh7c: -1,
        Kh6s: -1,
        Kh6h: -1,
        Kh6d: -1,
        Kh6c: -1,
        Kh5s: -1,
        Kh5h: -1,
        Kh5d: -1,
        Kh5c: -1,
        Kh4s: -1,
        Kh4h: -1,
        Kh4d: -1,
        Kh4c: -1,
        Kh3s: -1,
        Kh3h: -1,
        Kh3d: -1,
        Kh3c: -1,
        Kh2s: -1,
        Kh2h: -1,
        Kh2d: -1,
        Kh2c: -1,
        KdKc: -1,
        KdQs: -1,
        KdQh: -1,
        KdQd: 1,
        KdQc: -1,
        KdJs: -1,
        KdJh: -1,
        KdJd: 1,
        KdJc: -1,
        KdTs: -1,
        KdTh: -1,
        KdTd: 2,
        KdTc: -1,
        Kd9s: -1,
        Kd9h: -1,
        Kd9d: -1,
        Kd9c: -1,
        Kd8s: -1,
        Kd8h: -1,
        Kd8d: -1,
        Kd8c: -1,
        Kd7s: -1,
        Kd7h: -1,
        Kd7d: -1,
        Kd7c: -1,
        Kd6s: -1,
        Kd6h: -1,
        Kd6d: -1,
        Kd6c: -1,
        Kd5s: -1,
        Kd5h: -1,
        Kd5d: -1,
        Kd5c: -1,
        Kd4s: -1,
        Kd4h: -1,
        Kd4d: -1,
        Kd4c: -1,
        Kd3s: -1,
        Kd3h: -1,
        Kd3d: -1,
        Kd3c: -1,
        Kd2s: -1,
        Kd2h: -1,
        Kd2d: -1,
        Kd2c: -1,
        KcQs: -1,
        KcQh: -1,
        KcQd: -1,
        KcQc: -1,
        KcJs: -1,
        KcJh: -1,
        KcJd: -1,
        KcJc: -1,
        KcTs: -1,
        KcTh: -1,
        KcTd: -1,
        KcTc: -1,
        Kc9s: -1,
        Kc9h: -1,
        Kc9d: -1,
        Kc9c: -1,
        Kc8s: -1,
        Kc8h: -1,
        Kc8d: -1,
        Kc8c: -1,
        Kc7s: -1,
        Kc7h: -1,
        Kc7d: -1,
        Kc7c: -1,
        Kc6s: -1,
        Kc6h: -1,
        Kc6d: -1,
        Kc6c: -1,
        Kc5s: -1,
        Kc5h: -1,
        Kc5d: -1,
        Kc5c: -1,
        Kc4s: -1,
        Kc4h: -1,
        Kc4d: -1,
        Kc4c: -1,
        Kc3s: -1,
        Kc3h: -1,
        Kc3d: -1,
        Kc3c: -1,
        Kc2s: -1,
        Kc2h: -1,
        Kc2d: -1,
        Kc2c: -1,
        QsQh: -1,
        QsQd: -1,
        QsQc: -1,
        QsJs: -1,
        QsJh: -1,
        QsJd: -1,
        QsJc: -1,
        QsTs: -1,
        QsTh: -1,
        QsTd: -1,
        QsTc: -1,
        Qs9s: -1,
        Qs9h: -1,
        Qs9d: -1,
        Qs9c: -1,
        Qs8s: -1,
        Qs8h: -1,
        Qs8d: -1,
        Qs8c: -1,
        Qs7s: -1,
        Qs7h: -1,
        Qs7d: -1,
        Qs7c: -1,
        Qs6s: -1,
        Qs6h: -1,
        Qs6d: -1,
        Qs6c: -1,
        Qs5s: -1,
        Qs5h: -1,
        Qs5d: -1,
        Qs5c: -1,
        Qs4s: -1,
        Qs4h: -1,
        Qs4d: -1,
        Qs4c: -1,
        Qs3s: -1,
        Qs3h: -1,
        Qs3d: -1,
        Qs3c: -1,
        Qs2s: -1,
        Qs2h: -1,
        Qs2d: -1,
        Qs2c: -1,
        QhQd: -1,
        QhQc: -1,
        QhJs: -1,
        QhJh: -1,
        QhJd: -1,
        QhJc: -1,
        QhTs: -1,
        QhTh: -1,
        QhTd: -1,
        QhTc: -1,
        Qh9s: -1,
        Qh9h: -1,
        Qh9d: -1,
        Qh9c: -1,
        Qh8s: -1,
        Qh8h: -1,
        Qh8d: -1,
        Qh8c: -1,
        Qh7s: -1,
        Qh7h: -1,
        Qh7d: -1,
        Qh7c: -1,
        Qh6s: -1,
        Qh6h: -1,
        Qh6d: -1,
        Qh6c: -1,
        Qh5s: -1,
        Qh5h: -1,
        Qh5d: -1,
        Qh5c: -1,
        Qh4s: -1,
        Qh4h: -1,
        Qh4d: -1,
        Qh4c: -1,
        Qh3s: -1,
        Qh3h: -1,
        Qh3d: -1,
        Qh3c: -1,
        Qh2s: -1,
        Qh2h: -1,
        Qh2d: -1,
        Qh2c: -1,
        QdQc: -1,
        QdJs: -1,
        QdJh: -1,
        QdJd: -1,
        QdJc: -1,
        QdTs: -1,
        QdTh: -1,
        QdTd: 2,
        QdTc: -1,
        Qd9s: -1,
        Qd9h: -1,
        Qd9d: -1,
        Qd9c: -1,
        Qd8s: -1,
        Qd8h: -1,
        Qd8d: -1,
        Qd8c: -1,
        Qd7s: -1,
        Qd7h: -1,
        Qd7d: -1,
        Qd7c: -1,
        Qd6s: -1,
        Qd6h: -1,
        Qd6d: -1,
        Qd6c: -1,
        Qd5s: -1,
        Qd5h: -1,
        Qd5d: -1,
        Qd5c: -1,
        Qd4s: -1,
        Qd4h: -1,
        Qd4d: -1,
        Qd4c: -1,
        Qd3s: -1,
        Qd3h: -1,
        Qd3d: -1,
        Qd3c: -1,
        Qd2s: -1,
        Qd2h: -1,
        Qd2d: -1,
        Qd2c: -1,
        QcJs: -1,
        QcJh: -1,
        QcJd: -1,
        QcJc: -1,
        QcTs: -1,
        QcTh: -1,
        QcTd: -1,
        QcTc: -1,
        Qc9s: -1,
        Qc9h: -1,
        Qc9d: -1,
        Qc9c: -1,
        Qc8s: -1,
        Qc8h: -1,
        Qc8d: -1,
        Qc8c: -1,
        Qc7s: -1,
        Qc7h: -1,
        Qc7d: -1,
        Qc7c: -1,
        Qc6s: -1,
        Qc6h: -1,
        Qc6d: -1,
        Qc6c: -1,
        Qc5s: -1,
        Qc5h: -1,
        Qc5d: -1,
        Qc5c: -1,
        Qc4s: -1,
        Qc4h: -1,
        Qc4d: -1,
        Qc4c: -1,
        Qc3s: -1,
        Qc3h: -1,
        Qc3d: -1,
        Qc3c: -1,
        Qc2s: -1,
        Qc2h: -1,
        Qc2d: -1,
        Qc2c: -1,
        JsJh: -1,
        JsJd: -1,
        JsJc: -1,
        JsTs: -1,
        JsTh: -1,
        JsTd: -1,
        JsTc: -1,
        Js9s: -1,
        Js9h: -1,
        Js9d: -1,
        Js9c: -1,
        Js8s: -1,
        Js8h: -1,
        Js8d: -1,
        Js8c: -1,
        Js7s: -1,
        Js7h: -1,
        Js7d: -1,
        Js7c: -1,
        Js6s: -1,
        Js6h: -1,
        Js6d: -1,
        Js6c: -1,
        Js5s: -1,
        Js5h: -1,
        Js5d: -1,
        Js5c: -1,
        Js4s: -1,
        Js4h: -1,
        Js4d: -1,
        Js4c: -1,
        Js3s: -1,
        Js3h: -1,
        Js3d: -1,
        Js3c: -1,
        Js2s: -1,
        Js2h: -1,
        Js2d: -1,
        Js2c: -1,
        JhJd: -1,
        JhJc: -1,
        JhTs: -1,
        JhTh: -1,
        JhTd: -1,
        JhTc: -1,
        Jh9s: -1,
        Jh9h: -1,
        Jh9d: -1,
        Jh9c: -1,
        Jh8s: -1,
        Jh8h: -1,
        Jh8d: -1,
        Jh8c: -1,
        Jh7s: -1,
        Jh7h: -1,
        Jh7d: -1,
        Jh7c: -1,
        Jh6s: -1,
        Jh6h: -1,
        Jh6d: -1,
        Jh6c: -1,
        Jh5s: -1,
        Jh5h: -1,
        Jh5d: -1,
        Jh5c: -1,
        Jh4s: -1,
        Jh4h: -1,
        Jh4d: -1,
        Jh4c: -1,
        Jh3s: -1,
        Jh3h: -1,
        Jh3d: -1,
        Jh3c: -1,
        Jh2s: -1,
        Jh2h: -1,
        Jh2d: -1,
        Jh2c: -1,
        JdJc: -1,
        JdTs: -1,
        JdTh: -1,
        JdTd: 2,
        JdTc: -1,
        Jd9s: -1,
        Jd9h: -1,
        Jd9d: -1,
        Jd9c: -1,
        Jd8s: -1,
        Jd8h: -1,
        Jd8d: -1,
        Jd8c: -1,
        Jd7s: -1,
        Jd7h: -1,
        Jd7d: -1,
        Jd7c: -1,
        Jd6s: -1,
        Jd6h: -1,
        Jd6d: -1,
        Jd6c: -1,
        Jd5s: -1,
        Jd5h: -1,
        Jd5d: -1,
        Jd5c: -1,
        Jd4s: -1,
        Jd4h: -1,
        Jd4d: -1,
        Jd4c: -1,
        Jd3s: -1,
        Jd3h: -1,
        Jd3d: -1,
        Jd3c: -1,
        Jd2s: -1,
        Jd2h: -1,
        Jd2d: -1,
        Jd2c: -1,
        JcTs: -1,
        JcTh: -1,
        JcTd: -1,
        JcTc: -1,
        Jc9s: -1,
        Jc9h: -1,
        Jc9d: -1,
        Jc9c: -1,
        Jc8s: -1,
        Jc8h: -1,
        Jc8d: -1,
        Jc8c: -1,
        Jc7s: -1,
        Jc7h: -1,
        Jc7d: -1,
        Jc7c: -1,
        Jc6s: -1,
        Jc6h: -1,
        Jc6d: -1,
        Jc6c: -1,
        Jc5s: -1,
        Jc5h: -1,
        Jc5d: -1,
        Jc5c: -1,
        Jc4s: -1,
        Jc4h: -1,
        Jc4d: -1,
        Jc4c: -1,
        Jc3s: -1,
        Jc3h: -1,
        Jc3d: -1,
        Jc3c: -1,
        Jc2s: -1,
        Jc2h: -1,
        Jc2d: -1,
        Jc2c: -1,
        TsTh: -1,
        TsTd: -1,
        TsTc: -1,
        Ts9s: -1,
        Ts9h: -1,
        Ts9d: -1,
        Ts9c: -1,
        Ts8s: -1,
        Ts8h: -1,
        Ts8d: -1,
        Ts8c: -1,
        Ts7s: -1,
        Ts7h: -1,
        Ts7d: -1,
        Ts7c: -1,
        Ts6s: -1,
        Ts6h: -1,
        Ts6d: -1,
        Ts6c: -1,
        Ts5s: -1,
        Ts5h: -1,
        Ts5d: -1,
        Ts5c: -1,
        Ts4s: -1,
        Ts4h: -1,
        Ts4d: -1,
        Ts4c: -1,
        Ts3s: -1,
        Ts3h: -1,
        Ts3d: -1,
        Ts3c: -1,
        Ts2s: -1,
        Ts2h: -1,
        Ts2d: -1,
        Ts2c: -1,
        ThTd: -1,
        ThTc: -1,
        Th9s: -1,
        Th9h: -1,
        Th9d: -1,
        Th9c: -1,
        Th8s: -1,
        Th8h: -1,
        Th8d: -1,
        Th8c: -1,
        Th7s: -1,
        Th7h: -1,
        Th7d: -1,
        Th7c: -1,
        Th6s: -1,
        Th6h: -1,
        Th6d: -1,
        Th6c: -1,
        Th5s: -1,
        Th5h: -1,
        Th5d: -1,
        Th5c: -1,
        Th4s: -1,
        Th4h: -1,
        Th4d: -1,
        Th4c: -1,
        Th3s: -1,
        Th3h: -1,
        Th3d: -1,
        Th3c: -1,
        Th2s: -1,
        Th2h: -1,
        Th2d: -1,
        Th2c: -1,
        TdTc: -1,
        Td9s: -1,
        Td9h: -1,
        Td9d: 1,
        Td9c: -1,
        Td8s: -1,
        Td8h: -1,
        Td8d: -1,
        Td8c: -1,
        Td7s: -1,
        Td7h: -1,
        Td7d: -1,
        Td7c: -1,
        Td6s: -1,
        Td6h: -1,
        Td6d: -1,
        Td6c: -1,
        Td5s: -1,
        Td5h: -1,
        Td5d: -1,
        Td5c: -1,
        Td4s: -1,
        Td4h: -1,
        Td4d: -1,
        Td4c: -1,
        Td3s: -1,
        Td3h: -1,
        Td3d: -1,
        Td3c: -1,
        Td2s: -1,
        Td2h: -1,
        Td2d: -1,
        Td2c: -1,
        Tc9s: -1,
        Tc9h: -1,
        Tc9d: -1,
        Tc9c: -1,
        Tc8s: -1,
        Tc8h: -1,
        Tc8d: -1,
        Tc8c: -1,
        Tc7s: -1,
        Tc7h: -1,
        Tc7d: -1,
        Tc7c: -1,
        Tc6s: -1,
        Tc6h: -1,
        Tc6d: -1,
        Tc6c: -1,
        Tc5s: -1,
        Tc5h: -1,
        Tc5d: -1,
        Tc5c: -1,
        Tc4s: -1,
        Tc4h: -1,
        Tc4d: -1,
        Tc4c: -1,
        Tc3s: -1,
        Tc3h: -1,
        Tc3d: -1,
        Tc3c: -1,
        Tc2s: -1,
        Tc2h: -1,
        Tc2d: -1,
        Tc2c: -1,
        "9s9h": -1,
        "9s9d": -1,
        "9s9c": -1,
        "9s8s": -1,
        "9s8h": -1,
        "9s8d": -1,
        "9s8c": -1,
        "9s7s": -1,
        "9s7h": -1,
        "9s7d": -1,
        "9s7c": -1,
        "9s6s": -1,
        "9s6h": -1,
        "9s6d": -1,
        "9s6c": -1,
        "9s5s": -1,
        "9s5h": -1,
        "9s5d": -1,
        "9s5c": -1,
        "9s4s": -1,
        "9s4h": -1,
        "9s4d": -1,
        "9s4c": -1,
        "9s3s": -1,
        "9s3h": -1,
        "9s3d": -1,
        "9s3c": -1,
        "9s2s": -1,
        "9s2h": -1,
        "9s2d": -1,
        "9s2c": -1,
        "9h9d": -1,
        "9h9c": -1,
        "9h8s": -1,
        "9h8h": -1,
        "9h8d": -1,
        "9h8c": -1,
        "9h7s": -1,
        "9h7h": -1,
        "9h7d": -1,
        "9h7c": -1,
        "9h6s": -1,
        "9h6h": -1,
        "9h6d": -1,
        "9h6c": -1,
        "9h5s": -1,
        "9h5h": -1,
        "9h5d": -1,
        "9h5c": -1,
        "9h4s": -1,
        "9h4h": -1,
        "9h4d": -1,
        "9h4c": -1,
        "9h3s": -1,
        "9h3h": -1,
        "9h3d": -1,
        "9h3c": -1,
        "9h2s": -1,
        "9h2h": -1,
        "9h2d": -1,
        "9h2c": -1,
        "9d9c": -1,
        "9d8s": -1,
        "9d8h": -1,
        "9d8d": -1,
        "9d8c": -1,
        "9d7s": -1,
        "9d7h": -1,
        "9d7d": -1,
        "9d7c": -1,
        "9d6s": -1,
        "9d6h": -1,
        "9d6d": -1,
        "9d6c": -1,
        "9d5s": -1,
        "9d5h": -1,
        "9d5d": -1,
        "9d5c": -1,
        "9d4s": -1,
        "9d4h": -1,
        "9d4d": -1,
        "9d4c": -1,
        "9d3s": -1,
        "9d3h": -1,
        "9d3d": -1,
        "9d3c": -1,
        "9d2s": -1,
        "9d2h": -1,
        "9d2d": -1,
        "9d2c": -1,
        "9c8s": -1,
        "9c8h": -1,
        "9c8d": -1,
        "9c8c": -1,
        "9c7s": -1,
        "9c7h": -1,
        "9c7d": -1,
        "9c7c": -1,
        "9c6s": -1,
        "9c6h": -1,
        "9c6d": -1,
        "9c6c": -1,
        "9c5s": -1,
        "9c5h": -1,
        "9c5d": -1,
        "9c5c": -1,
        "9c4s": -1,
        "9c4h": -1,
        "9c4d": -1,
        "9c4c": -1,
        "9c3s": -1,
        "9c3h": -1,
        "9c3d": -1,
        "9c3c": -1,
        "9c2s": -1,
        "9c2h": -1,
        "9c2d": -1,
        "9c2c": -1,
        "8s8h": 0,
        "8s8d": 0,
        "8s8c": 0,
        "8s7s": -1,
        "8s7h": -1,
        "8s7d": -1,
        "8s7c": -1,
        "8s6s": -1,
        "8s6h": -1,
        "8s6d": -1,
        "8s6c": -1,
        "8s5s": -1,
        "8s5h": -1,
        "8s5d": -1,
        "8s5c": -1,
        "8s4s": -1,
        "8s4h": -1,
        "8s4d": -1,
        "8s4c": -1,
        "8s3s": -1,
        "8s3h": -1,
        "8s3d": -1,
        "8s3c": -1,
        "8s2s": -1,
        "8s2h": -1,
        "8s2d": -1,
        "8s2c": -1,
        "8h8d": 0,
        "8h8c": 0,
        "8h7s": -1,
        "8h7h": -1,
        "8h7d": -1,
        "8h7c": -1,
        "8h6s": -1,
        "8h6h": -1,
        "8h6d": -1,
        "8h6c": -1,
        "8h5s": -1,
        "8h5h": -1,
        "8h5d": -1,
        "8h5c": -1,
        "8h4s": -1,
        "8h4h": -1,
        "8h4d": -1,
        "8h4c": -1,
        "8h3s": -1,
        "8h3h": -1,
        "8h3d": -1,
        "8h3c": -1,
        "8h2s": -1,
        "8h2h": -1,
        "8h2d": -1,
        "8h2c": -1,
        "8d8c": 0,
        "8d7s": -1,
        "8d7h": -1,
        "8d7d": -1,
        "8d7c": -1,
        "8d6s": -1,
        "8d6h": -1,
        "8d6d": -1,
        "8d6c": -1,
        "8d5s": -1,
        "8d5h": -1,
        "8d5d": -1,
        "8d5c": -1,
        "8d4s": -1,
        "8d4h": -1,
        "8d4d": -1,
        "8d4c": -1,
        "8d3s": -1,
        "8d3h": -1,
        "8d3d": -1,
        "8d3c": -1,
        "8d2s": -1,
        "8d2h": -1,
        "8d2d": -1,
        "8d2c": -1,
        "8c7s": -1,
        "8c7h": -1,
        "8c7d": -1,
        "8c7c": -1,
        "8c6s": -1,
        "8c6h": -1,
        "8c6d": -1,
        "8c6c": -1,
        "8c5s": -1,
        "8c5h": -1,
        "8c5d": -1,
        "8c5c": -1,
        "8c4s": -1,
        "8c4h": -1,
        "8c4d": -1,
        "8c4c": -1,
        "8c3s": -1,
        "8c3h": -1,
        "8c3d": -1,
        "8c3c": -1,
        "8c2s": -1,
        "8c2h": -1,
        "8c2d": -1,
        "8c2c": -1,
        "7s7h": -1,
        "7s7d": -1,
        "7s7c": -1,
        "7s6s": -1,
        "7s6h": -1,
        "7s6d": -1,
        "7s6c": -1,
        "7s5s": -1,
        "7s5h": -1,
        "7s5d": -1,
        "7s5c": -1,
        "7s4s": -1,
        "7s4h": -1,
        "7s4d": -1,
        "7s4c": -1,
        "7s3s": -1,
        "7s3h": -1,
        "7s3d": -1,
        "7s3c": -1,
        "7s2s": -1,
        "7s2h": -1,
        "7s2d": -1,
        "7s2c": -1,
        "7h7d": -1,
        "7h7c": -1,
        "7h6s": -1,
        "7h6h": -1,
        "7h6d": -1,
        "7h6c": -1,
        "7h5s": -1,
        "7h5h": -1,
        "7h5d": -1,
        "7h5c": -1,
        "7h4s": -1,
        "7h4h": -1,
        "7h4d": -1,
        "7h4c": -1,
        "7h3s": -1,
        "7h3h": -1,
        "7h3d": -1,
        "7h3c": -1,
        "7h2s": -1,
        "7h2h": -1,
        "7h2d": -1,
        "7h2c": -1,
        "7d7c": -1,
        "7d6s": -1,
        "7d6h": -1,
        "7d6d": -1,
        "7d6c": -1,
        "7d5s": -1,
        "7d5h": -1,
        "7d5d": -1,
        "7d5c": -1,
        "7d4s": -1,
        "7d4h": -1,
        "7d4d": -1,
        "7d4c": -1,
        "7d3s": -1,
        "7d3h": -1,
        "7d3d": -1,
        "7d3c": -1,
        "7d2s": -1,
        "7d2h": -1,
        "7d2d": -1,
        "7d2c": -1,
        "7c6s": -1,
        "7c6h": -1,
        "7c6d": -1,
        "7c6c": -1,
        "7c5s": -1,
        "7c5h": -1,
        "7c5d": -1,
        "7c5c": -1,
        "7c4s": -1,
        "7c4h": -1,
        "7c4d": -1,
        "7c4c": -1,
        "7c3s": -1,
        "7c3h": -1,
        "7c3d": -1,
        "7c3c": -1,
        "7c2s": -1,
        "7c2h": -1,
        "7c2d": -1,
        "7c2c": -1,
        "6s6h": -1,
        "6s6d": -1,
        "6s6c": -1,
        "6s5s": -1,
        "6s5h": -1,
        "6s5d": -1,
        "6s5c": -1,
        "6s4s": -1,
        "6s4h": -1,
        "6s4d": -1,
        "6s4c": -1,
        "6s3s": -1,
        "6s3h": -1,
        "6s3d": -1,
        "6s3c": -1,
        "6s2s": -1,
        "6s2h": -1,
        "6s2d": -1,
        "6s2c": -1,
        "6h6d": -1,
        "6h6c": -1,
        "6h5s": -1,
        "6h5h": -1,
        "6h5d": -1,
        "6h5c": -1,
        "6h4s": -1,
        "6h4h": -1,
        "6h4d": -1,
        "6h4c": -1,
        "6h3s": -1,
        "6h3h": -1,
        "6h3d": -1,
        "6h3c": -1,
        "6h2s": -1,
        "6h2h": -1,
        "6h2d": -1,
        "6h2c": -1,
        "6d6c": -1,
        "6d5s": -1,
        "6d5h": -1,
        "6d5d": -1,
        "6d5c": -1,
        "6d4s": -1,
        "6d4h": -1,
        "6d4d": -1,
        "6d4c": -1,
        "6d3s": -1,
        "6d3h": -1,
        "6d3d": -1,
        "6d3c": -1,
        "6d2s": -1,
        "6d2h": -1,
        "6d2d": -1,
        "6d2c": -1,
        "6c5s": -1,
        "6c5h": -1,
        "6c5d": -1,
        "6c5c": -1,
        "6c4s": -1,
        "6c4h": -1,
        "6c4d": -1,
        "6c4c": -1,
        "6c3s": -1,
        "6c3h": -1,
        "6c3d": -1,
        "6c3c": -1,
        "6c2s": -1,
        "6c2h": -1,
        "6c2d": -1,
        "6c2c": -1,
        "5s5h": 0,
        "5s5d": 0,
        "5s5c": 0,
        "5s4s": -1,
        "5s4h": -1,
        "5s4d": -1,
        "5s4c": -1,
        "5s3s": -1,
        "5s3h": -1,
        "5s3d": -1,
        "5s3c": -1,
        "5s2s": -1,
        "5s2h": -1,
        "5s2d": -1,
        "5s2c": -1,
        "5h5d": 0,
        "5h5c": 0,
        "5h4s": -1,
        "5h4h": -1,
        "5h4d": -1,
        "5h4c": -1,
        "5h3s": -1,
        "5h3h": -1,
        "5h3d": -1,
        "5h3c": -1,
        "5h2s": -1,
        "5h2h": -1,
        "5h2d": -1,
        "5h2c": -1,
        "5d5c": 0,
        "5d4s": -1,
        "5d4h": -1,
        "5d4d": -1,
        "5d4c": -1,
        "5d3s": -1,
        "5d3h": -1,
        "5d3d": -1,
        "5d3c": -1,
        "5d2s": -1,
        "5d2h": -1,
        "5d2d": -1,
        "5d2c": -1,
        "5c4s": -1,
        "5c4h": -1,
        "5c4d": -1,
        "5c4c": -1,
        "5c3s": -1,
        "5c3h": -1,
        "5c3d": -1,
        "5c3c": -1,
        "5c2s": -1,
        "5c2h": -1,
        "5c2d": -1,
        "5c2c": -1,
        "4s4h": -1,
        "4s4d": -1,
        "4s4c": -1,
        "4s3s": -1,
        "4s3h": -1,
        "4s3d": -1,
        "4s3c": -1,
        "4s2s": -1,
        "4s2h": -1,
        "4s2d": -1,
        "4s2c": -1,
        "4h4d": -1,
        "4h4c": -1,
        "4h3s": -1,
        "4h3h": -1,
        "4h3d": -1,
        "4h3c": -1,
        "4h2s": -1,
        "4h2h": -1,
        "4h2d": -1,
        "4h2c": -1,
        "4d4c": -1,
        "4d3s": -1,
        "4d3h": -1,
        "4d3d": -1,
        "4d3c": -1,
        "4d2s": -1,
        "4d2h": -1,
        "4d2d": -1,
        "4d2c": -1,
        "4c3s": -1,
        "4c3h": -1,
        "4c3d": -1,
        "4c3c": -1,
        "4c2s": -1,
        "4c2h": -1,
        "4c2d": -1,
        "4c2c": -1,
        "3s3h": -1,
        "3s3d": -1,
        "3s3c": -1,
        "3s2s": -1,
        "3s2h": -1,
        "3s2d": -1,
        "3s2c": -1,
        "3h3d": -1,
        "3h3c": -1,
        "3h2s": -1,
        "3h2h": -1,
        "3h2d": -1,
        "3h2c": -1,
        "3d3c": -1,
        "3d2s": -1,
        "3d2h": -1,
        "3d2d": -1,
        "3d2c": -1,
        "3c2s": -1,
        "3c2h": -1,
        "3c2d": -1,
        "3c2c": -1,
        "2s2h": -1,
        "2s2d": -1,
        "2s2c": -1,
        "2h2d": -1,
        "2h2c": -1,
        "2d2c": -1,
      },
      fixedCards: 4,
    },
    id: 3,
  },
];
